const chessGames = [
	{
		title: "Kasparov's Immortal",
		chessgameid: 1011478,
		player1: "Kasparov",
		player2: "Topalov",
		year: 1999,
		opening: "(B07) Pirc",
		nbMoves: 44,
		score: "1-0",
		finalPosition: "/positions/1011478.png"
	},
	{
		title: "Fischer's Immortal-The Game Of The Century.",
		chessgameid: 1008361,
		player1: "D Byrne",
		player2: "Fischer",
		year: 1956,
		opening: "(D92) Grunfeld, 5.Bf4",
		nbMoves: 41,
		score: "0-1",
		finalPosition: "/positions/1008361.png"
	},
	{
		title: "Nunn's Immortal",
		chessgameid: 1103322,
		player1: "Beliavsky",
		player2: "Nunn",
		year: 1985,
		opening: "(E81) King's Indian, Samisch",
		nbMoves: 27,
		score: "0-1",
		finalPosition: "/positions/1103322.png"
	},
	{
		title: "Yusupov's Immortal",
		chessgameid: 1060180,
		player1: "Ivanchuk",
		player2: "Yusupov",
		year: 1991,
		opening: "(E67) King's Indian, Fianchetto",
		nbMoves: 39,
		score: "0-1",
		finalPosition: "/positions/1060180.png"
	},
	{
		title: "Rubinstein's Immortal",
		chessgameid: 1119679,
		player1: "Rotlewi",
		player2: "Rubinstein",
		year: 1907,
		opening: "(D32) Queen's Gambit Declined, Tarrasch",
		nbMoves: 25,
		score: "0-1",
		finalPosition: "/positions/1119679.png"
	},
	{
		title: "Nezhmetdinov's Immortal",
		chessgameid: 1111459,
		player1: "Polugaevsky",
		player2: "R Nezhmetdinov",
		year: 1958,
		opening: "(A54) Old Indian, Ukrainian Variation, 4.Nf3",
		nbMoves: 33,
		score: "0-1",
		finalPosition: "/positions/1111459.png"
	},
	{
		title: "Gufeld's Immortal",
		chessgameid: 1023029,
		player1: "Bagirov",
		player2: "Gufeld",
		year: 1973,
		opening: "(E84) King's Indian, Samisch, Panno Main line",
		nbMoves: 32,
		score: "0-1",
		finalPosition: "/positions/1023029.png"
	},
	{
		title: "Tal's Immortal",
		chessgameid: 1139729,
		player1: "Tal",
		player2: "Larsen",
		year: 1965,
		opening: "(B82) Sicilian, Scheveningen",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1139729.png"
	},
	{
		title: "The Immortal Nakamura!",
		chessgameid: 1477101,
		player1: "Krasenkow",
		player2: "Nakamura",
		year: 2007,
		opening: "(A14) English",
		nbMoves: 28,
		score: "0-1",
		finalPosition: "/positions/1477101.png"
	},
	{
		title: "The Immortal Game.",
		chessgameid: 1018910,
		player1: "Anderssen",
		player2: "Kieseritzky",
		year: 1851,
		opening: "(C33) King's Gambit Accepted",
		nbMoves: 23,
		score: "1-0",
		finalPosition: "/positions/1018910.png"
	},
	{
		title: "The Most Famous Game of All Time",
		chessgameid: 1233404,
		player1: "Morphy",
		player2: "Duke Karl / Count Isouard",
		year: 1858,
		opening: "(C41) Philidor Defense",
		nbMoves: 17,
		score: "1-0",
		finalPosition: "/positions/1233404.png"
	},
	{
		title: "Morphy's Immortal",
		chessgameid: 1019060,
		player1: "Morphy",
		player2: "Anderssen",
		year: 1858,
		opening: "(C39) King's Gambit Accepted",
		nbMoves: 23,
		score: "1-0",
		finalPosition: "/positions/1019060.png"
	},
	{
		title: "30.Ba3!! Mind boggling game.",
		chessgameid: 1031957,
		player1: "Botvinnik",
		player2: "Capablanca",
		year: 1938,
		opening: "(E40) Nimzo-Indian, 4.e3",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1031957.png"
	},
	{
		title: "The Evergreen Game.",
		chessgameid: 1018961,
		player1: "Anderssen",
		player2: "Dufresne",
		year: 1852,
		opening: "(C52) Evans Gambit",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1018961.png"
	},
	{
		title: "Simply Amazing!",
		chessgameid: 1186636,
		player1: "Nakamura",
		player2: "J W Loyte",
		year: 2001,
		opening: "(B01) Scandinavian",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1186636.png"
	},
	{
		title: "36.Rc5!! amazing depth.",
		chessgameid: 1140914,
		player1: "Tal",
		player2: "Hjartarson",
		year: 1987,
		opening: "(C97) Ruy Lopez, Closed, Chigorin",
		nbMoves: 43,
		score: "1-0",
		finalPosition: "/positions/1140914.png"
	},
	{
		title: "Petrov's Immortal.",
		chessgameid: 1257910,
		player1: "F A Hoffmann",
		player2: "A Petrov",
		year: 1844,
		opening: "(C53) Giuoco Piano",
		nbMoves: 20,
		score: "0-1",
		finalPosition: "/positions/1257910.png"
	},
	{
		title: "Zukertort's Immortal",
		chessgameid: 1001854,
		player1: "Zukertort",
		player2: "Blackburne",
		year: 1883,
		opening: "(A13) English",
		nbMoves: 33,
		score: "1-0",
		finalPosition: "/positions/1001854.png"
	},
	{
		title: "Smyslov's Immortal",
		chessgameid: 1032320,
		player1: "Botvinnik",
		player2: "Smyslov",
		year: 1954,
		opening: "(E67) King's Indian, Fianchetto",
		nbMoves: 33,
		score: "0-1",
		finalPosition: "/positions/1032320.png"
	},
	{
		title: "Karpov's Immortal",
		chessgameid: 1069169,
		player1: "Karpov",
		player2: "Topalov",
		year: 1994,
		opening: "(A32) English, Symmetrical Variation",
		nbMoves: 39,
		score: "1-0",
		finalPosition: "/positions/1069169.png"
	},
	{
		title: "Anand's Immortal",
		chessgameid: 1385670,
		player1: "Karjakin",
		player2: "Anand",
		year: 2006,
		opening: "(B90) Sicilian, Najdorf",
		nbMoves: 37,
		score: "0-1",
		finalPosition: "/positions/1385670.png"
	},
	{
		title: "Capablanca's Immortal Zugzwang in the style of \"My System\"!",
		chessgameid: 1007846,
		player1: "Nimzowitsch",
		player2: "Capablanca",
		year: 1927,
		opening: "(B12) Caro-Kann Defense",
		nbMoves: 46,
		score: "0-1",
		finalPosition: "/positions/1007846.png"
	},
	{
		title: "Double B sac,King hunt and an X-ray mate.",
		chessgameid: 1102384,
		player1: "Nimzowitsch",
		player2: "Tarrasch",
		year: 1914,
		opening: "(D30) Queen's Gambit Declined",
		nbMoves: 32,
		score: "0-1",
		finalPosition: "/positions/1102384.png"
	},
	{
		title: "R. Byrne's Knightmare",
		chessgameid: 1008419,
		player1: "R Byrne",
		player2: "Fischer",
		year: 1963,
		opening: "(E60) King's Indian Defense",
		nbMoves: 21,
		score: "0-1",
		finalPosition: "/positions/1008419.png"
	},
	{
		title: "Attack on the King stuck in the center.",
		chessgameid: 1132699,
		player1: "Steinitz",
		player2: "Von Bardeleben",
		year: 1895,
		opening: "(C54) Giuoco Piano",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1132699.png"
	},
	{
		title: "Najdorf's Immortal",
		chessgameid: 1100774,
		player1: "Glucksberg",
		player2: "Najdorf",
		year: 1929,
		opening: "(A85) Dutch, with c4 & Nc3",
		nbMoves: 22,
		score: "0-1",
		finalPosition: "/positions/1100774.png"
	},
	{
		title: "A Brilliancy among Brilliancies.",
		chessgameid: 1053943,
		player1: "Hoi",
		player2: "Gulko",
		year: 1988,
		opening: "(A40) Queen's Pawn Game",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1053943.png"
	},
	{
		title: "The  Immortal Sacrifice Exchange Game. 6 sacs  4 exchs",
		chessgameid: 1289099,
		player1: "Serper",
		player2: "I Nikolaidis",
		year: 1993,
		opening: "(E70) King's Indian",
		nbMoves: 48,
		score: "1-0",
		finalPosition: "/positions/1289099.png"
	},
	{
		title: "Best game of the match 1972.",
		chessgameid: 1044366,
		player1: "Fischer",
		player2: "Spassky",
		year: 1972,
		opening: "(D59) Queen's Gambit Declined, Tartakower",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1044366.png"
	},
	{
		title: "Kasparov's Gem- his favorite.",
		chessgameid: 1067175,
		player1: "Karpov",
		player2: "Kasparov",
		year: 1985,
		opening: "(B44) Sicilian",
		nbMoves: 40,
		score: "0-1",
		finalPosition: "/positions/1067175.png"
	},
	{
		title: "Jaw dropping game.Amazing sacrifices.",
		chessgameid: 1260278,
		player1: "R Nezhmetdinov",
		player2: "O Chernikov",
		year: 1962,
		opening: "(B32) Sicilian",
		nbMoves: 33,
		score: "1-0",
		finalPosition: "/positions/1260278.png"
	},
	{
		title: "The mighty Ruy Lopez-Kasparov style.",
		chessgameid: 1067209,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1986,
		opening: "(C92) Ruy Lopez, Closed",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1067209.png"
	},
	{
		title: "Nakamura vs Shabalov no name",
		chessgameid: 1340361,
		player1: "Nakamura",
		player2: "Shabalov",
		year: 2005,
		opening: "(D35) Queen's Gambit Declined",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1340361.png"
	},
	{
		title: "Another Immortal Sacrifice Game. 6 sacs",
		chessgameid: 1340393,
		player1: "L Milman",
		player2: "J Fang",
		year: 2005,
		opening: "(B18) Caro-Kann, Classical",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1340393.png"
	},
	{
		title: "A bizarre and brilliant game with a Q sac and a windmill.",
		chessgameid: 1084375,
		player1: "Averbakh",
		player2: "Kotov",
		year: 1953,
		opening: "(A55) Old Indian, Main line",
		nbMoves: 51,
		score: "0-1",
		finalPosition: "/positions/1084375.png"
	},
	{
		title: "Kingside attack World Champion style.",
		chessgameid: 1067294,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1990,
		opening: "(C92) Ruy Lopez, Closed",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1067294.png"
	},
	{
		title: "Strategic R sac and game winning Q sac.Superb game!",
		chessgameid: 1268187,
		player1: "Sagalchik",
		player2: "Nakamura",
		year: 2003,
		opening: "(C12) French, McCutcheon",
		nbMoves: 37,
		score: "0-1",
		finalPosition: "/positions/1268187.png"
	},
	{
		title: "Morphy's famous queen sac.",
		chessgameid: 1242884,
		player1: "Paulsen",
		player2: "Morphy",
		year: 1857,
		opening: "(C48) Four Knights",
		nbMoves: 28,
		score: "0-1",
		finalPosition: "/positions/1242884.png"
	},
	{
		title: "A game we will see in a future tactics book.Brilliant!",
		chessgameid: 1272702,
		player1: "Carlsen",
		player2: "S Ernst",
		year: 2004,
		opening: "(B18) Caro-Kann, Classical",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1272702.png"
	},
	{
		title: "R takes N on f6! Brilliant King-side attack.",
		chessgameid: 1282608,
		player1: "Ragozin",
		player2: "P Noskov",
		year: 1930,
		opening: "(B40) Sicilian",
		nbMoves: 21,
		score: "1-0",
		finalPosition: "/positions/1282608.png"
	},
	{
		title: "Amazing King-side attack and Q sac.Very instructive.",
		chessgameid: 1132189,
		player1: "Krogius",
		player2: "Stein",
		year: 1960,
		opening: "(E92) King's Indian",
		nbMoves: 43,
		score: "0-1",
		finalPosition: "/positions/1132189.png"
	},
	{
		title: "The famous double bishop sac.",
		chessgameid: 1026352,
		player1: "Lasker",
		player2: "J Bauer",
		year: 1889,
		opening: "(A03) Bird's Opening",
		nbMoves: 38,
		score: "1-0",
		finalPosition: "/positions/1026352.png"
	},
	{
		title: "All Lopez players must study is brilliant game.",
		chessgameid: 1019058,
		player1: "Morphy",
		player2: "Anderssen",
		year: 1858,
		opening: "(C65) Ruy Lopez, Berlin Defense",
		nbMoves: 20,
		score: "1-0",
		finalPosition: "/positions/1019058.png"
	},
	{
		title: "It's always better to sacrifice your opponents pieces",
		chessgameid: 1427466,
		player1: "Ragozin",
		player2: "P Romanovsky",
		year: 1927,
		opening: "(A04) Reti Opening",
		nbMoves: 24,
		score: "0-1",
		finalPosition: "/positions/1427466.png"
	},
	{
		title: "29.Bg2!! The greatest quiet move of all time.",
		chessgameid: 1044267,
		player1: "Fischer",
		player2: "Myagmarsuren",
		year: 1967,
		opening: "(A07) King's Indian Attack",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1044267.png"
	},
	{
		title: "A real beauty.Square by square control.",
		chessgameid: 1007465,
		player1: "P Johner",
		player2: "Nimzowitsch",
		year: 1926,
		opening: "(E47) Nimzo-Indian, 4.e3 O-O 5.Bd3",
		nbMoves: 40,
		score: "0-1",
		finalPosition: "/positions/1007465.png"
	},
	{
		title: "White N outpost at d5 in the sicilian creates huge attack.",
		chessgameid: 1070747,
		player1: "Kasparov",
		player2: "Kramnik",
		year: 1994,
		opening: "(B33) Sicilian",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1070747.png"
	},
	{
		title: "The Greatest Chess Move Ever Played !!!",
		chessgameid: 1094915,
		player1: "S Levitsky",
		player2: "Marshall",
		year: 1912,
		opening: "(B23) Sicilian, Closed",
		nbMoves: 23,
		score: "0-1",
		finalPosition: "/positions/1094915.png"
	},
	{
		title: "Rook endgame masterpiece.",
		chessgameid: 1102104,
		player1: "Capablanca",
		player2: "Tartakower",
		year: 1924,
		opening: "(A40) Queen's Pawn Game",
		nbMoves: 52,
		score: "1-0",
		finalPosition: "/positions/1102104.png"
	},
	{
		title: "A great attack on f7,and  a brutal see-saw check.",
		chessgameid: 1228798,
		player1: "M Kupferstich",
		player2: "H Andreasen",
		year: 1953,
		opening: "(C27) Vienna Game",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1228798.png"
	},
	{
		title: "Brilliant game with amazing Q sac",
		chessgameid: 1144002,
		player1: "Torre",
		player2: "N Banks",
		year: 1924,
		opening: "(A46) Queen's Pawn Game",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1144002.png"
	},
	{
		title: "A Nimzo style positional brilliancy.",
		chessgameid: 1067846,
		player1: "Karpov",
		player2: "Unzicker",
		year: 1974,
		opening: "(C98) Ruy Lopez, Closed, Chigorin",
		nbMoves: 44,
		score: "1-0",
		finalPosition: "/positions/1067846.png"
	},
	{
		title: "Amazing tactics and sacrifices.Fantastic finish.",
		chessgameid: 1106725,
		player1: "Petrosian",
		player2: "Spassky",
		year: 1966,
		opening: "(E63) King's Indian, Fianchetto, Panno Variation",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1106725.png"
	},
	{
		title: "The Immortal Zugzwang",
		chessgameid: 1102400,
		player1: "Saemisch",
		player2: "Nimzowitsch",
		year: 1923,
		opening: "(E18) Queen's Indian, Old Main line, 7.Nc3",
		nbMoves: 25,
		score: "0-1",
		finalPosition: "/positions/1102400.png"
	},
	{
		title: "Pawn Power",
		chessgameid: 1007571,
		player1: "Rubinstein",
		player2: "Alekhine",
		year: 1926,
		opening: "(E16) Queen's Indian",
		nbMoves: 29,
		score: "0-1",
		finalPosition: "/positions/1007571.png"
	},
	{
		title: "Crushing control of space.",
		chessgameid: 1012099,
		player1: "Bogoljubov",
		player2: "Alekhine",
		year: 1922,
		opening: "(A90) Dutch",
		nbMoves: 53,
		score: "0-1",
		finalPosition: "/positions/1012099.png"
	},
	{
		title: "Pawn Power",
		chessgameid: 1261710,
		player1: "Gufeld",
		player2: "Kavalek",
		year: 1962,
		opening: "(C64) Ruy Lopez, Classical",
		nbMoves: 32,
		score: "0-1",
		finalPosition: "/positions/1261710.png"
	},
	{
		title: "Tal's brilliant attack.",
		chessgameid: 1139363,
		player1: "Tal",
		player2: "Koblents",
		year: 1957,
		opening: "(B63) Sicilian, Richter-Rauzer Attack",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1139363.png"
	},
	{
		title: "Capablanca's favorite game.",
		chessgameid: 1261680,
		player1: "O Bernstein",
		player2: "Capablanca",
		year: 1914,
		opening: "(D63) Queen's Gambit Declined, Orthodox Defense",
		nbMoves: 29,
		score: "0-1",
		finalPosition: "/positions/1261680.png"
	},
	{
		title: "31.Qf1!! A brilliant anti-sicilian.",
		chessgameid: 1008371,
		player1: "Fischer",
		player2: "J Sherwin",
		year: 1957,
		opening: "(B90) Sicilian, Najdorf",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1008371.png"
	},
	{
		title: "A strategic queenside attack brilliancy.",
		chessgameid: 1075094,
		player1: "Rubinstein",
		player2: "Hromadka",
		year: 1923,
		opening: "(C30) King's Gambit Declined",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1075094.png"
	},
	{
		title: "Zwischenzug! and 2 perplexing N sacs.",
		chessgameid: 1032537,
		player1: "Botvinnik",
		player2: "Tal",
		year: 1960,
		opening: "(E69) King's Indian, Fianchetto, Classical Main line",
		nbMoves: 47,
		score: "0-1",
		finalPosition: "/positions/1032537.png"
	},
	{
		title: "The Rook or (hog) on the 7th rank.",
		chessgameid: 1032787,
		player1: "Botvinnik",
		player2: "Portisch",
		year: 1968,
		opening: "(A22) English",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1032787.png"
	},
	{
		title: "A Strategic Brilliancy! very instructive.",
		chessgameid: 1397132,
		player1: "Gufeld",
		player2: "B Ivanovic",
		year: 1979,
		opening: "(B33) Sicilian",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1397132.png"
	},
	{
		title: "21.Rxd4!! Fantastic use of the Bishops for mate.",
		chessgameid: 1036342,
		player1: "Steinitz",
		player2: "Chigorin",
		year: 1892,
		opening: "(C65) Ruy Lopez, Berlin Defense",
		nbMoves: 28,
		score: "1-0",
		finalPosition: "/positions/1036342.png"
	},
	{
		title: "Sacs both Rooks .Opens H-file ,then mate.",
		chessgameid: 1003826,
		player1: "Maroczy",
		player2: "Tartakower",
		year: 1922,
		opening: "(A84) Dutch",
		nbMoves: 35,
		score: "0-1",
		finalPosition: "/positions/1003826.png"
	},
	{
		title: "Knight torture",
		chessgameid: 1012326,
		player1: "Reti",
		player2: "Alekhine",
		year: 1925,
		opening: "(A00) Uncommon Opening",
		nbMoves: 40,
		score: "0-1",
		finalPosition: "/positions/1012326.png"
	},
	{
		title: "Fischer goes hypermodern,sacs his N and B for mate.",
		chessgameid: 1044324,
		player1: "Fischer",
		player2: "Panno",
		year: 1970,
		opening: "(A07) King's Indian Attack",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1044324.png"
	},
	{
		title: "Karopov's pieces go back home.Pawn Power Wins.",
		chessgameid: 1067319,
		player1: "Karpov",
		player2: "Kasparov",
		year: 1993,
		opening: "(E86) King's Indian, Samisch, Orthodox, 7.Nge2 c6",
		nbMoves: 27,
		score: "0-1",
		finalPosition: "/positions/1067319.png"
	},
	{
		title: "The amazing King march.",
		chessgameid: 1124533,
		player1: "Short",
		player2: "Timman",
		year: 1991,
		opening: "(B04) Alekhine's Defense, Modern",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1124533.png"
	},
	{
		title: "A Fischer-like N attack and King hunt.",
		chessgameid: 1262430,
		player1: "Cifuentes Parada",
		player2: "Zvjaginsev",
		year: 1995,
		opening: "(D45) Queen's Gambit Declined Semi-Slav",
		nbMoves: 35,
		score: "0-1",
		finalPosition: "/positions/1262430.png"
	},
	{
		title: "A truly artistic game,with an amazing Q sac.",
		chessgameid: 1152958,
		player1: "Stoltz",
		player2: "H Steiner",
		year: 1952,
		opening: "(A21) English",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1152958.png"
	},
	{
		title: "The Swindler gets Swindled! A Famous Game.",
		chessgameid: 1095025,
		player1: "Capablanca",
		player2: "Marshall",
		year: 1918,
		opening: "(C89) Ruy Lopez, Marshall",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1095025.png"
	},
	{
		title: "Positional brilliancy by Kasparov.Amazing Q sac.",
		chessgameid: 1070732,
		player1: "Kramnik",
		player2: "Kasparov",
		year: 1994,
		opening: "(E92) King's Indian",
		nbMoves: 39,
		score: "0-1",
		finalPosition: "/positions/1070732.png"
	},
	{
		title: "Polgar vs Adams no name",
		chessgameid: 1009910,
		player1: "Polgar",
		player2: "Adams",
		year: 1999,
		opening: "(C89) Ruy Lopez, Marshall",
		nbMoves: 45,
		score: "0-1",
		finalPosition: "/positions/1009910.png"
	},
	{
		title: "Oll vs Ulybin no name",
		chessgameid: 1258270,
		player1: "Oll",
		player2: "Ulybin",
		year: 1989,
		opening: "(C18) French, Winawer",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1258270.png"
	},
	{
		title: "E Korchmar vs Y Polyak no name",
		chessgameid: 1269834,
		player1: "E Korchmar",
		player2: "Y Polyak",
		year: 1937,
		opening: "(C62) Ruy Lopez, Old Steinitz Defense",
		nbMoves: 23,
		score: "1-0",
		finalPosition: "/positions/1269834.png"
	},
	{
		title: "Amazing skill with the minor pieces.Great exchange sacs.",
		chessgameid: 1042533,
		player1: "Euwe",
		player2: "Keres",
		year: 1940,
		opening: "(E19) Queen's Indian, Old Main line, 9.Qxc3",
		nbMoves: 34,
		score: "0-1",
		finalPosition: "/positions/1042533.png"
	},
	{
		title: "Lasker calls out the King with R exchange sacs.",
		chessgameid: 1109097,
		player1: "Pillsbury",
		player2: "Lasker",
		year: 1896,
		opening: "(D50) Queen's Gambit Declined",
		nbMoves: 30,
		score: "0-1",
		finalPosition: "/positions/1109097.png"
	},
	{
		title: "Pillsbury vs Lasker no name",
		chessgameid: 1109111,
		player1: "Pillsbury",
		player2: "Lasker",
		year: 1896,
		opening: "(C11) French",
		nbMoves: 50,
		score: "1-0",
		finalPosition: "/positions/1109111.png"
	},
	{
		title: "Nakamura vs S Muhammad no name",
		chessgameid: 1322027,
		player1: "Nakamura",
		player2: "S Muhammad",
		year: 2004,
		opening: "(C78) Ruy Lopez",
		nbMoves: 28,
		score: "1-0",
		finalPosition: "/positions/1322027.png"
	},
	{
		title: "Bird vs Morphy no name",
		chessgameid: 1027914,
		player1: "Bird",
		player2: "Morphy",
		year: 1858,
		opening: "(C41) Philidor Defense",
		nbMoves: 29,
		score: "0-1",
		finalPosition: "/positions/1027914.png"
	},
	{
		title: "A dynamic brilliancy by Kramnik.",
		chessgameid: 1060694,
		player1: "Ivanchuk",
		player2: "Kramnik",
		year: 1996,
		opening: "(B62) Sicilian, Richter-Rauzer",
		nbMoves: 32,
		score: "0-1",
		finalPosition: "/positions/1060694.png"
	},
	{
		title: "Brilliant Tactical Game and Rook sac",
		chessgameid: 1289665,
		player1: "Ilyin-Zhenevsky",
		player2: "P Romanovsky",
		year: 1929,
		opening: "(B17) Caro-Kann, Steinitz Variation",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1289665.png"
	},
	{
		title: "The threat of mate creates deadly tactics.",
		chessgameid: 1034337,
		player1: "Kholmov",
		player2: "Bronstein",
		year: 1965,
		opening: "(B99) Sicilian, Najdorf, 7...Be7 Main line",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1034337.png"
	},
	{
		title: "A great minor piece battle.Very instructive.",
		chessgameid: 1044022,
		player1: "Fischer",
		player2: "Stein",
		year: 1967,
		opening: "(C92) Ruy Lopez, Closed",
		nbMoves: 56,
		score: "1-0",
		finalPosition: "/positions/1044022.png"
	},
	{
		title: "All out attack on the uncastled King with positional sacs.",
		chessgameid: 1018785,
		player1: "Anand",
		player2: "Lautier",
		year: 1997,
		opening: "(B01) Scandinavian",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1018785.png"
	},
	{
		title: "The Q takes the R sac. R goes to the 2nd rank.",
		chessgameid: 1042835,
		player1: "Geller",
		player2: "Euwe",
		year: 1953,
		opening: "(E26) Nimzo-Indian, Samisch",
		nbMoves: 26,
		score: "0-1",
		finalPosition: "/positions/1042835.png"
	},
	{
		title: "Classic King side attack.",
		chessgameid: 1008421,
		player1: "Fischer",
		player2: "Benko",
		year: 1963,
		opening: "(B09) Pirc, Austrian Attack",
		nbMoves: 21,
		score: "1-0",
		finalPosition: "/positions/1008421.png"
	},
	{
		title: "Karpov vs Korchnoi no name",
		chessgameid: 1067858,
		player1: "Karpov",
		player2: "Korchnoi",
		year: 1974,
		opening: "(B77) Sicilian, Dragon, Yugoslav Attack",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1067858.png"
	},
	{
		title: "Tal vs Karpov no name",
		chessgameid: 1067017,
		player1: "Tal",
		player2: "Karpov",
		year: 1987,
		opening: "(B10) Caro-Kann",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1067017.png"
	},
	{
		title: "Anand vs Gelfand no name",
		chessgameid: 1387996,
		player1: "Anand",
		player2: "Gelfand",
		year: 2006,
		opening: "(B90) Sicilian, Najdorf",
		nbMoves: 66,
		score: "1-0",
		finalPosition: "/positions/1387996.png"
	},
	{
		title: "Ljubojevic vs Andersson no name",
		chessgameid: 1019762,
		player1: "Ljubojevic",
		player2: "Andersson",
		year: 1976,
		opening: "(B47) Sicilian, Taimanov (Bastrikov) Variation",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1019762.png"
	},
	{
		title: "Sacs both rooks and Q for a mating net on the uncastled King.",
		chessgameid: 1008397,
		player1: "Letelier",
		player2: "Fischer",
		year: 1960,
		opening: "(E70) King's Indian",
		nbMoves: 23,
		score: "0-1",
		finalPosition: "/positions/1008397.png"
	},
	{
		title: "Polugaevsky vs E Torre no name",
		chessgameid: 1041460,
		player1: "Polugaevsky",
		player2: "E Torre",
		year: 1981,
		opening: "(D44) Queen's Gambit Declined Semi-Slav",
		nbMoves: 40,
		score: "1-0",
		finalPosition: "/positions/1041460.png"
	},
	{
		title: "Great N and R sacs crush the Najdorf.",
		chessgameid: 1091272,
		player1: "Velimirovic",
		player2: "Ljubojevic",
		year: 1972,
		opening: "(B99) Sicilian, Najdorf, 7...Be7 Main line",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1091272.png"
	},
	{
		title: "Ivanchuk vs Shirov no name",
		chessgameid: 1060750,
		player1: "Ivanchuk",
		player2: "Shirov",
		year: 1996,
		opening: "(D44) Queen's Gambit Declined Semi-Slav",
		nbMoves: 35,
		score: "1-0",
		finalPosition: "/positions/1060750.png"
	},
	{
		title: "Sacs both Rooks for pawn promotion threat.",
		chessgameid: 1090846,
		player1: "Lilienthal",
		player2: "Ragozin",
		year: 1935,
		opening: "(E24) Nimzo-Indian, Samisch",
		nbMoves: 47,
		score: "0-1",
		finalPosition: "/positions/1090846.png"
	},
	{
		title: "Kasparov vs Portisch no name",
		chessgameid: 1070074,
		player1: "Kasparov",
		player2: "Portisch",
		year: 1983,
		opening: "(E12) Queen's Indian",
		nbMoves: 35,
		score: "1-0",
		finalPosition: "/positions/1070074.png"
	},
	{
		title: "Gruenfeld vs Alekhine no name",
		chessgameid: 1012180,
		player1: "Gruenfeld",
		player2: "Alekhine",
		year: 1923,
		opening: "(D64) Queen's Gambit Declined, Orthodox, Rubinstein Attack",
		nbMoves: 34,
		score: "0-1",
		finalPosition: "/positions/1012180.png"
	},
	{
		title: "M Leon Hoyos vs Nakamura no name",
		chessgameid: 1390015,
		player1: "M Leon Hoyos",
		player2: "Nakamura",
		year: 2006,
		opening: "(A04) Reti Opening",
		nbMoves: 53,
		score: "0-1",
		finalPosition: "/positions/1390015.png"
	},
	{
		title: "A brilliant back row mate threat.",
		chessgameid: 1030774,
		player1: "Reti",
		player2: "Bogoljubov",
		year: 1924,
		opening: "(A13) English",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1030774.png"
	},
	{
		title: "Gelfand vs Kramnik no name",
		chessgameid: 1284067,
		player1: "Gelfand",
		player2: "Kramnik",
		year: 1996,
		opening: "(D45) Queen's Gambit Declined Semi-Slav",
		nbMoves: 28,
		score: "0-1",
		finalPosition: "/positions/1284067.png"
	},
	{
		title: "Kramnik vs Leko no name",
		chessgameid: 1311652,
		player1: "Kramnik",
		player2: "Leko",
		year: 2004,
		opening: "(B12) Caro-Kann Defense",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1311652.png"
	},
	{
		title: "Famous Game.",
		chessgameid: 1271822,
		player1: "Cochrane",
		player2: "Staunton",
		year: 1841,
		opening: "(C23) Bishop's Opening",
		nbMoves: 20,
		score: "0-1",
		finalPosition: "/positions/1271822.png"
	},
	{
		title: "Famous Game,\"Pawns are the Soul of Chess\"",
		chessgameid: 1259660,
		player1: "Philidor",
		player2: "NN",
		year: 1749,
		opening: "(C20) King's Pawn Game",
		nbMoves: 40,
		score: "1-0",
		finalPosition: "/positions/1259660.png"
	},
	{
		title: "Charousek vs J Wollner no name",
		chessgameid: 1036115,
		player1: "Charousek",
		player2: "J Wollner",
		year: 1893,
		opening: "(C21) Center Game",
		nbMoves: 19,
		score: "1-0",
		finalPosition: "/positions/1036115.png"
	},
	{
		title: "The proverbial \"Chess Battle\".An all time classic.",
		chessgameid: 1034661,
		player1: "Bronstein",
		player2: "Ljubojevic",
		year: 1973,
		opening: "(B03) Alekhine's Defense",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1034661.png"
	},
	{
		title: "Geller tears down the castle.",
		chessgameid: 1049156,
		player1: "Geller",
		player2: "Smyslov",
		year: 1965,
		opening: "(D87) Grunfeld, Exchange",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1049156.png"
	},
	{
		title: "Keres nails the Najdorf with a dynamic attack.",
		chessgameid: 1136833,
		player1: "Keres",
		player2: "Szabo",
		year: 1955,
		opening: "(B64) Sicilian, Richter-Rauzer Attack",
		nbMoves: 23,
		score: "1-0",
		finalPosition: "/positions/1136833.png"
	},
	{
		title: "Fischer vs Geller no name",
		chessgameid: 1044020,
		player1: "Fischer",
		player2: "Geller",
		year: 1967,
		opening: "(B89) Sicilian",
		nbMoves: 23,
		score: "0-1",
		finalPosition: "/positions/1044020.png"
	},
	{
		title: "Fischer vs Geller no name",
		chessgameid: 1044264,
		player1: "Fischer",
		player2: "Geller",
		year: 1967,
		opening: "(B97) Sicilian, Najdorf",
		nbMoves: 25,
		score: "0-1",
		finalPosition: "/positions/1044264.png"
	},
	{
		title: "Kholmov vs Keres no name",
		chessgameid: 1072785,
		player1: "Kholmov",
		player2: "Keres",
		year: 1959,
		opening: "(B30) Sicilian",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1072785.png"
	},
	{
		title: "Nakamura vs I Cheparinov no name",
		chessgameid: 1392643,
		player1: "Nakamura",
		player2: "I Cheparinov",
		year: 2006,
		opening: "(D44) Queen's Gambit Declined Semi-Slav",
		nbMoves: 44,
		score: "1-0",
		finalPosition: "/positions/1392643.png"
	},
	{
		title: "Korchnoi vs Udovcic no name",
		chessgameid: 1081771,
		player1: "Korchnoi",
		player2: "Udovcic",
		year: 1967,
		opening: "(C05) French, Tarrasch",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1081771.png"
	},
	{
		title: "Fischer vs Petrosian no name",
		chessgameid: 1044351,
		player1: "Fischer",
		player2: "Petrosian",
		year: 1971,
		opening: "(B42) Sicilian, Kan",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1044351.png"
	},
	{
		title: "Bronstein vs Keres no name",
		chessgameid: 1033895,
		player1: "Bronstein",
		player2: "Keres",
		year: 1955,
		opening: "(E41) Nimzo-Indian",
		nbMoves: 39,
		score: "1-0",
		finalPosition: "/positions/1033895.png"
	},
	{
		title: "Adams vs Topalov no name",
		chessgameid: 1385770,
		player1: "Adams",
		player2: "Topalov",
		year: 2006,
		opening: "(B84) Sicilian, Scheveningen",
		nbMoves: 42,
		score: "1-0",
		finalPosition: "/positions/1385770.png"
	},
	{
		title: "Nakamura vs Smirin no name",
		chessgameid: 1355804,
		player1: "Nakamura",
		player2: "Smirin",
		year: 2005,
		opening: "(B09) Pirc, Austrian Attack",
		nbMoves: 22,
		score: "1-0",
		finalPosition: "/positions/1355804.png"
	},
	{
		title: "Kasparov vs Csom no name",
		chessgameid: 1069830,
		player1: "Kasparov",
		player2: "Csom",
		year: 1980,
		opening: "(E42) Nimzo-Indian, 4.e3 c5, 5.Ne2 (Rubinstein)",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1069830.png"
	},
	{
		title: "K Bischoff vs J Nogueiras no name",
		chessgameid: 1282935,
		player1: "K Bischoff",
		player2: "J Nogueiras",
		year: 1998,
		opening: "(A11) English, Caro-Kann Defensive System",
		nbMoves: 40,
		score: "1-0",
		finalPosition: "/positions/1282935.png"
	},
	{
		title: "Lasker vs W Napier no name",
		chessgameid: 1036787,
		player1: "Lasker",
		player2: "W Napier",
		year: 1904,
		opening: "(B25) Sicilian, Closed",
		nbMoves: 35,
		score: "1-0",
		finalPosition: "/positions/1036787.png"
	},
	{
		title: "Larsen vs Spassky no name",
		chessgameid: 1128831,
		player1: "Larsen",
		player2: "Spassky",
		year: 1970,
		opening: "(A01) Nimzovich-Larsen Attack",
		nbMoves: 17,
		score: "0-1",
		finalPosition: "/positions/1128831.png"
	},
	{
		title: "Fischer vs Larsen no name",
		chessgameid: 1008373,
		player1: "Fischer",
		player2: "Larsen",
		year: 1958,
		opening: "(B77) Sicilian, Dragon, Yugoslav Attack",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1008373.png"
	},
	{
		title: "Spassky vs Fischer no name",
		chessgameid: 1044722,
		player1: "Spassky",
		player2: "Fischer",
		year: 1972,
		opening: "(E56) Nimzo-Indian, 4.e3, Main line with 7...Nc6",
		nbMoves: 56,
		score: "1-0",
		finalPosition: "/positions/1044722.png"
	},
	{
		title: "Nakamura vs T Hillarp Persson no name",
		chessgameid: 1337330,
		player1: "Nakamura",
		player2: "T Hillarp Persson",
		year: 2005,
		opening: "(C02) French, Advance",
		nbMoves: 100,
		score: "1-0",
		finalPosition: "/positions/1337330.png"
	},
	{
		title: "Korchnoi vs Spassky no name",
		chessgameid: 1080843,
		player1: "Korchnoi",
		player2: "Spassky",
		year: 1948,
		opening: "(B71) Sicilian, Dragon, Levenfish Variation",
		nbMoves: 12,
		score: "1-0",
		finalPosition: "/positions/1080843.png"
	},
	{
		title: "Fischer vs Tal no name",
		chessgameid: 1044001,
		player1: "Fischer",
		player2: "Tal",
		year: 1959,
		opening: "(B87) Sicilian, Fischer-Sozin with ...a6 and ...b5",
		nbMoves: 52,
		score: "0-1",
		finalPosition: "/positions/1044001.png"
	},
	{
		title: "Portisch vs Pinter no name",
		chessgameid: 1063968,
		player1: "Portisch",
		player2: "Pinter",
		year: 1984,
		opening: "(D41) Queen's Gambit Declined, Semi-Tarrasch",
		nbMoves: 33,
		score: "0-1",
		finalPosition: "/positions/1063968.png"
	},
	{
		title: "Ivanchuk vs S Volkov no name",
		chessgameid: 1361556,
		player1: "Ivanchuk",
		player2: "S Volkov",
		year: 2005,
		opening: "(C11) French",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1361556.png"
	},
	{
		title: "Capablanca vs J Corzo no name",
		chessgameid: 1262431,
		player1: "Capablanca",
		player2: "J Corzo",
		year: 1901,
		opening: "(D02) Queen's Pawn Game",
		nbMoves: 60,
		score: "1-0",
		finalPosition: "/positions/1262431.png"
	},
	{
		title: "Stripunsky vs Nakamura no name",
		chessgameid: 1460803,
		player1: "Stripunsky",
		player2: "Nakamura",
		year: 2007,
		opening: "(B76) Sicilian, Dragon, Yugoslav Attack",
		nbMoves: 28,
		score: "0-1",
		finalPosition: "/positions/1460803.png"
	},
	{
		title: "Spassky vs Fischer no name",
		chessgameid: 1008424,
		player1: "Spassky",
		player2: "Fischer",
		year: 1972,
		opening: "(B46) Sicilian, Taimanov Variation",
		nbMoves: 41,
		score: "0-1",
		finalPosition: "/positions/1008424.png"
	},
	{
		title: "Kasparov vs Smirin no name",
		chessgameid: 1070350,
		player1: "Kasparov",
		player2: "Smirin",
		year: 1988,
		opening: "(E97) King's Indian",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1070350.png"
	},
	{
		title: "Korchnoi vs Tal no name",
		chessgameid: 1081478,
		player1: "Korchnoi",
		player2: "Tal",
		year: 1962,
		opening: "(A62) Benoni, Fianchetto Variation",
		nbMoves: 54,
		score: "1-0",
		finalPosition: "/positions/1081478.png"
	},
	{
		title: "F Thorbergsson vs Tal no name",
		chessgameid: 1139701,
		player1: "F Thorbergsson",
		player2: "Tal",
		year: 1964,
		opening: "(E77) King's Indian",
		nbMoves: 39,
		score: "0-1",
		finalPosition: "/positions/1139701.png"
	},
	{
		title: "Tal vs Smyslov no name",
		chessgameid: 1139475,
		player1: "Tal",
		player2: "Smyslov",
		year: 1959,
		opening: "(B10) Caro-Kann",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1139475.png"
	},
	{
		title: "Alekhine vs Yates no name",
		chessgameid: 1012179,
		player1: "Alekhine",
		player2: "Yates",
		year: 1923,
		opening: "(E62) King's Indian, Fianchetto",
		nbMoves: 50,
		score: "0-1",
		finalPosition: "/positions/1012179.png"
	},
	{
		title: "Fischer vs Reshevsky no name",
		chessgameid: 1008376,
		player1: "Fischer",
		player2: "Reshevsky",
		year: 1958,
		opening: "(B32) Sicilian",
		nbMoves: 42,
		score: "1-0",
		finalPosition: "/positions/1008376.png"
	},
	{
		title: "Spassky vs Polugaevsky no name",
		chessgameid: 1111542,
		player1: "Spassky",
		player2: "Polugaevsky",
		year: 1961,
		opening: "(E21) Nimzo-Indian, Three Knights",
		nbMoves: 42,
		score: "1-0",
		finalPosition: "/positions/1111542.png"
	},
	{
		title: "Spassky vs Bronstein no name",
		chessgameid: 1034110,
		player1: "Spassky",
		player2: "Bronstein",
		year: 1960,
		opening: "(C36) King's Gambit Accepted, Abbazia Defense",
		nbMoves: 23,
		score: "1-0",
		finalPosition: "/positions/1034110.png"
	},
	{
		title: "O M Hindle vs G Moehring no name",
		chessgameid: 1282936,
		player1: "O M Hindle",
		player2: "G Moehring",
		year: 1964,
		opening: "(C44) King's Pawn Game",
		nbMoves: 77,
		score: "0-1",
		finalPosition: "/positions/1282936.png"
	},
	{
		title: "Fischer vs Spassky no name",
		chessgameid: 1044389,
		player1: "Fischer",
		player2: "Spassky",
		year: 1992,
		opening: "(C69) Ruy Lopez, Exchange, Gligoric Variation",
		nbMoves: 21,
		score: "1-0",
		finalPosition: "/positions/1044389.png"
	},
	{
		title: "Fischer vs Larsen no name",
		chessgameid: 1044346,
		player1: "Fischer",
		player2: "Larsen",
		year: 1971,
		opening: "(C19) French, Winawer, Advance",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1044346.png"
	},
	{
		title: "Geller vs Keres no name",
		chessgameid: 1049696,
		player1: "Geller",
		player2: "Keres",
		year: 1973,
		opening: "(C87) Ruy Lopez",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1049696.png"
	},
	{
		title: "Petrosian vs Pachman no name",
		chessgameid: 1104948,
		player1: "Petrosian",
		player2: "Pachman",
		year: 1961,
		opening: "(A07) King's Indian Attack",
		nbMoves: 21,
		score: "1-0",
		finalPosition: "/positions/1104948.png"
	},
	{
		title: "Smyslov vs Liberzon no name",
		chessgameid: 1126235,
		player1: "Smyslov",
		player2: "Liberzon",
		year: 1968,
		opening: "(A25) English",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1126235.png"
	},
	{
		title: "THE MOST BRUTAL ATTACK OF ALL TIME",
		chessgameid: 1071404,
		player1: "Keene",
		player2: "Miles",
		year: 1976,
		opening: "(D42) Queen's Gambit Declined, Semi-Tarrasch, 7.Bd3",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1071404.png"
	},
	{
		title: "Topalov vs Aronian no name",
		chessgameid: 1387655,
		player1: "Topalov",
		player2: "Aronian",
		year: 2006,
		opening: "(E15) Queen's Indian",
		nbMoves: 44,
		score: "1-0",
		finalPosition: "/positions/1387655.png"
	},
	{
		title: "Tal vs R Forbis no name",
		chessgameid: 1140969,
		player1: "Tal",
		player2: "R Forbis",
		year: 1988,
		opening: "(B77) Sicilian, Dragon, Yugoslav Attack",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1140969.png"
	},
	{
		title: "Pillsbury vs Tarrasch no name",
		chessgameid: 1109079,
		player1: "Pillsbury",
		player2: "Tarrasch",
		year: 1895,
		opening: "(D63) Queen's Gambit Declined, Orthodox Defense",
		nbMoves: 52,
		score: "1-0",
		finalPosition: "/positions/1109079.png"
	},
	{
		title: "Spassky vs Tal no name",
		chessgameid: 1129088,
		player1: "Spassky",
		player2: "Tal",
		year: 1979,
		opening: "(E14) Queen's Indian",
		nbMoves: 22,
		score: "0-1",
		finalPosition: "/positions/1129088.png"
	},
	{
		title: "A sneaky double Bishop sac.",
		chessgameid: 1138648,
		player1: "Taimanov",
		player2: "A Shashin",
		year: 1978,
		opening: "(A04) Reti Opening",
		nbMoves: 28,
		score: "1-0",
		finalPosition: "/positions/1138648.png"
	},
	{
		title: "Fomenko vs L Radchenko no name",
		chessgameid: 1224915,
		player1: "Fomenko",
		player2: "L Radchenko",
		year: 1967,
		opening: "(C59) Two Knights",
		nbMoves: 25,
		score: "0-1",
		finalPosition: "/positions/1224915.png"
	},
	{
		title: "Fischer vs Unzicker no name",
		chessgameid: 1044340,
		player1: "Fischer",
		player2: "Unzicker",
		year: 1970,
		opening: "(C69) Ruy Lopez, Exchange, Gligoric Variation",
		nbMoves: 42,
		score: "1-0",
		finalPosition: "/positions/1044340.png"
	},
	{
		title: "Tal vs Hecht no name",
		chessgameid: 1139582,
		player1: "Tal",
		player2: "Hecht",
		year: 1962,
		opening: "(E12) Queen's Indian",
		nbMoves: 49,
		score: "1-0",
		finalPosition: "/positions/1139582.png"
	},
	{
		title: "C de Ronde vs H Kamstra no name",
		chessgameid: 1269833,
		player1: "C de Ronde",
		player2: "H Kamstra",
		year: 1938,
		opening: "(E80) King's Indian, Samisch Variation",
		nbMoves: 50,
		score: "1-0",
		finalPosition: "/positions/1269833.png"
	},
	{
		title: "Fischer vs Tal no name",
		chessgameid: 1008404,
		player1: "Fischer",
		player2: "Tal",
		year: 1961,
		opening: "(B47) Sicilian, Taimanov (Bastrikov) Variation",
		nbMoves: 47,
		score: "1-0",
		finalPosition: "/positions/1008404.png"
	},
	{
		title: "Short vs Kasparov no name",
		chessgameid: 1070587,
		player1: "Short",
		player2: "Kasparov",
		year: 1992,
		opening: "(B93) Sicilian, Najdorf, 6.f4",
		nbMoves: 37,
		score: "0-1",
		finalPosition: "/positions/1070587.png"
	},
	{
		title: "A J Mestel vs Gufeld no name",
		chessgameid: 1397133,
		player1: "A J Mestel",
		player2: "Gufeld",
		year: 1987,
		opening: "(E80) King's Indian, Samisch Variation",
		nbMoves: 27,
		score: "0-1",
		finalPosition: "/positions/1397133.png"
	},
	{
		title: "P Romanovsky vs I Rabinovich no name",
		chessgameid: 1427465,
		player1: "P Romanovsky",
		player2: "I Rabinovich",
		year: 1925,
		opening: "(C16) French, Winawer",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1427465.png"
	},
	{
		title: "M Thinius vs Beim no name",
		chessgameid: 1278812,
		player1: "M Thinius",
		player2: "Beim",
		year: 1993,
		opening: "(B08) Pirc, Classical",
		nbMoves: 35,
		score: "0-1",
		finalPosition: "/positions/1278812.png"
	},
	{
		title: "Nakamura vs Karjakin no name",
		chessgameid: 1326707,
		player1: "Nakamura",
		player2: "Karjakin",
		year: 2004,
		opening: "(B23) Sicilian, Closed",
		nbMoves: 55,
		score: "1-0",
		finalPosition: "/positions/1326707.png"
	},
	{
		title: "Fischer vs Larsen no name",
		chessgameid: 1044348,
		player1: "Fischer",
		player2: "Larsen",
		year: 1971,
		opening: "(B88) Sicilian, Fischer-Sozin Attack",
		nbMoves: 46,
		score: "1-0",
		finalPosition: "/positions/1044348.png"
	},
	{
		title: "J Friedel vs Nakamura no name",
		chessgameid: 1460764,
		player1: "J Friedel",
		player2: "Nakamura",
		year: 2007,
		opening: "(C11) French",
		nbMoves: 51,
		score: "0-1",
		finalPosition: "/positions/1460764.png"
	},
	{
		title: "Ed. Lasker vs G A Thomas no name",
		chessgameid: 1259009,
		player1: "Ed. Lasker",
		player2: "G A Thomas",
		year: 1912,
		opening: "(A40) Queen's Pawn Game",
		nbMoves: 18,
		score: "1-0",
		finalPosition: "/positions/1259009.png"
	},
	{
		title: "Kasparov vs Short no name",
		chessgameid: 1070679,
		player1: "Kasparov",
		player2: "Short",
		year: 1993,
		opening: "(C84) Ruy Lopez, Closed",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1070679.png"
	},
	{
		title: "J Reinisch vs Traxler no name",
		chessgameid: 1224609,
		player1: "J Reinisch",
		player2: "Traxler",
		year: 1890,
		opening: "(C57) Two Knights",
		nbMoves: 17,
		score: "0-1",
		finalPosition: "/positions/1224609.png"
	},
	{
		title: "Kasparov vs Kamsky no name",
		chessgameid: 1066716,
		player1: "Kasparov",
		player2: "Kamsky",
		year: 1993,
		opening: "(B80) Sicilian, Scheveningen",
		nbMoves: 35,
		score: "1-0",
		finalPosition: "/positions/1066716.png"
	},
	{
		title: "Kasparov vs Anand no name",
		chessgameid: 1018270,
		player1: "Kasparov",
		player2: "Anand",
		year: 1991,
		opening: "(B48) Sicilian, Taimanov Variation",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1018270.png"
	},
	{
		title: "Keene vs V Kovacevic no name",
		chessgameid: 1071336,
		player1: "Keene",
		player2: "V Kovacevic",
		year: 1973,
		opening: "(A06) Reti Opening",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1071336.png"
	},
	{
		title: "Geller vs Fischer no name",
		chessgameid: 1044555,
		player1: "Geller",
		player2: "Fischer",
		year: 1962,
		opening: "(B92) Sicilian, Najdorf, Opocensky Variation",
		nbMoves: 40,
		score: "1-0",
		finalPosition: "/positions/1044555.png"
	},
	{
		title: "Short vs R J Miles no name",
		chessgameid: 1123803,
		player1: "Short",
		player2: "R J Miles",
		year: 1976,
		opening: "(B07) Pirc",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1123803.png"
	},
	{
		title: "Zhao Xue vs D Reizniece-Ozola no name",
		chessgameid: 1416497,
		player1: "Zhao Xue",
		player2: "D Reizniece-Ozola",
		year: 2006,
		opening: "(E92) King's Indian",
		nbMoves: 56,
		score: "1-0",
		finalPosition: "/positions/1416497.png"
	},
	{
		title: "Bobotsov vs Tal no name",
		chessgameid: 1139428,
		player1: "Bobotsov",
		player2: "Tal",
		year: 1958,
		opening: "(E81) King's Indian, Samisch",
		nbMoves: 30,
		score: "0-1",
		finalPosition: "/positions/1139428.png"
	},
	{
		title: "Karpov vs Korchnoi no name",
		chessgameid: 1038811,
		player1: "Karpov",
		player2: "Korchnoi",
		year: 1994,
		opening: "(E12) Queen's Indian",
		nbMoves: 72,
		score: "0-1",
		finalPosition: "/positions/1038811.png"
	},
	{
		title: "Korchnoi vs Karpov no name",
		chessgameid: 1067831,
		player1: "Korchnoi",
		player2: "Karpov",
		year: 1974,
		opening: "(E17) Queen's Indian",
		nbMoves: 19,
		score: "1-0",
		finalPosition: "/positions/1067831.png"
	},
	{
		title: "Geller vs Karpov no name",
		chessgameid: 1049829,
		player1: "Geller",
		player2: "Karpov",
		year: 1976,
		opening: "(C16) French, Winawer",
		nbMoves: 42,
		score: "1-0",
		finalPosition: "/positions/1049829.png"
	},
	{
		title: "Geller vs Kogan no name",
		chessgameid: 1048417,
		player1: "Geller",
		player2: "Kogan",
		year: 1946,
		opening: "(B53) Sicilian",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1048417.png"
	},
	{
		title: "Tal vs Sviridov no name",
		chessgameid: 1139414,
		player1: "Tal",
		player2: "Sviridov",
		year: 1969,
		opening: "(B75) Sicilian, Dragon, Yugoslav Attack",
		nbMoves: 18,
		score: "1-0",
		finalPosition: "/positions/1139414.png"
	},
	{
		title: "Tal vs J Miller no name",
		chessgameid: 1259999,
		player1: "Tal",
		player2: "J Miller",
		year: 1988,
		opening: "(C55) Two Knights Defense",
		nbMoves: 33,
		score: "1-0",
		finalPosition: "/positions/1259999.png"
	},
	{
		title: "Tartakower vs Euwe no name",
		chessgameid: 1156038,
		player1: "Tartakower",
		player2: "Euwe",
		year: 1948,
		opening: "(C53) Giuoco Piano",
		nbMoves: 42,
		score: "0-1",
		finalPosition: "/positions/1156038.png"
	},
	{
		title: "Euwe vs Alekhine no name",
		chessgameid: 1013180,
		player1: "Euwe",
		player2: "Alekhine",
		year: 1935,
		opening: "(A90) Dutch",
		nbMoves: 47,
		score: "1-0",
		finalPosition: "/positions/1013180.png"
	},
	{
		title: "Euwe vs Najdorf no name",
		chessgameid: 1042813,
		player1: "Euwe",
		player2: "Najdorf",
		year: 1953,
		opening: "(E60) King's Indian Defense",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1042813.png"
	},
	{
		title: "Euwe vs S B van Mindeno no name",
		chessgameid: 1042266,
		player1: "Euwe",
		player2: "S B van Mindeno",
		year: 1927,
		opening: "(C54) Giuoco Piano",
		nbMoves: 17,
		score: "1-0",
		finalPosition: "/positions/1042266.png"
	},
	{
		title: "Fischer vs S Schweber no name",
		chessgameid: 1044333,
		player1: "Fischer",
		player2: "S Schweber",
		year: 1970,
		opening: "(C18) French, Winawer",
		nbMoves: 47,
		score: "1-0",
		finalPosition: "/positions/1044333.png"
	},
	{
		title: "Blackburne vs J Schwarz no name",
		chessgameid: 1029022,
		player1: "Blackburne",
		player2: "J Schwarz",
		year: 1881,
		opening: "(C01) French, Exchange",
		nbMoves: 28,
		score: "1-0",
		finalPosition: "/positions/1029022.png"
	},
	{
		title: "B Greenwald vs Fischer no name",
		chessgameid: 1044578,
		player1: "B Greenwald",
		player2: "Fischer",
		year: 1963,
		opening: "(D86) Grunfeld, Exchange",
		nbMoves: 29,
		score: "0-1",
		finalPosition: "/positions/1044578.png"
	},
	{
		title: "Bogoljubov vs J Mieses no name",
		chessgameid: 1007170,
		player1: "Bogoljubov",
		player2: "J Mieses",
		year: 1925,
		opening: "(A90) Dutch",
		nbMoves: 35,
		score: "1-0",
		finalPosition: "/positions/1007170.png"
	},
	{
		title: "Bogoljubov vs Spielmann no name",
		chessgameid: 1030643,
		player1: "Bogoljubov",
		player2: "Spielmann",
		year: 1919,
		opening: "(C13) French",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1030643.png"
	},
	{
		title: "Nimzowitsch vs Hakansson no name",
		chessgameid: 1102392,
		player1: "Nimzowitsch",
		player2: "Hakansson",
		year: 1922,
		opening: "(C02) French, Advance",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1102392.png"
	},
	{
		title: "Nimzowitsch vs Rubinstein no name",
		chessgameid: 1007481,
		player1: "Nimzowitsch",
		player2: "Rubinstein",
		year: 1926,
		opening: "(A34) English, Symmetrical",
		nbMoves: 46,
		score: "1-0",
		finalPosition: "/positions/1007481.png"
	},
	{
		title: "Nimzowitsch vs Alapin no name",
		chessgameid: 1102375,
		player1: "Nimzowitsch",
		player2: "Alapin",
		year: 1914,
		opening: "(C11) French",
		nbMoves: 18,
		score: "1-0",
		finalPosition: "/positions/1102375.png"
	},
	{
		title: "N Mannheimer vs Nimzowitsch no name",
		chessgameid: 1102446,
		player1: "N Mannheimer",
		player2: "Nimzowitsch",
		year: 1930,
		opening: "(C01) French, Exchange",
		nbMoves: 44,
		score: "0-1",
		finalPosition: "/positions/1102446.png"
	},
	{
		title: "Steinitz vs Rock no name",
		chessgameid: 1274802,
		player1: "Steinitz",
		player2: "Rock",
		year: 1863,
		opening: "(000) Chess variants",
		nbMoves: 18,
		score: "1-0",
		finalPosition: "/positions/1274802.png"
	},
	{
		title: "Steinitz vs Paulsen no name",
		chessgameid: 1255422,
		player1: "Steinitz",
		player2: "Paulsen",
		year: 1870,
		opening: "(C25) Vienna",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1255422.png"
	},
	{
		title: "Zukertort vs Steinitz no name",
		chessgameid: 1132661,
		player1: "Zukertort",
		player2: "Steinitz",
		year: 1886,
		opening: "(D50) Queen's Gambit Declined",
		nbMoves: 29,
		score: "0-1",
		finalPosition: "/positions/1132661.png"
	},
	{
		title: "Botvinnik vs Chekhover no name",
		chessgameid: 1031877,
		player1: "Botvinnik",
		player2: "Chekhover",
		year: 1935,
		opening: "(A13) English",
		nbMoves: 43,
		score: "1-0",
		finalPosition: "/positions/1031877.png"
	},
	{
		title: "Botvinnik vs Keres no name",
		chessgameid: 1032736,
		player1: "Botvinnik",
		player2: "Keres",
		year: 1966,
		opening: "(A29) English, Four Knights, Kingside Fianchetto",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1032736.png"
	},
	{
		title: "Botvinnik vs Vidmar no name",
		chessgameid: 1008258,
		player1: "Botvinnik",
		player2: "Vidmar",
		year: 1936,
		opening: "(D60) Queen's Gambit Declined, Orthodox Defense",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1008258.png"
	},
	{
		title: "Chigorin vs Znosko-Borovsky no name",
		chessgameid: 1036571,
		player1: "Chigorin",
		player2: "Znosko-Borovsky",
		year: 1903,
		opening: "(C31) King's Gambit Declined, Falkbeer Counter Gambit",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1036571.png"
	},
	{
		title: "Chigorin vs J Mortimer no name",
		chessgameid: 1000089,
		player1: "Chigorin",
		player2: "J Mortimer",
		year: 1900,
		opening: "(C25) Vienna",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1000089.png"
	},
	{
		title: "Lasker vs Capablanca no name",
		chessgameid: 1258181,
		player1: "Lasker",
		player2: "Capablanca",
		year: 1914,
		opening: "(C68) Ruy Lopez, Exchange",
		nbMoves: 42,
		score: "1-0",
		finalPosition: "/positions/1258181.png"
	},
	{
		title: "Euwe vs Lasker no name",
		chessgameid: 1008008,
		player1: "Euwe",
		player2: "Lasker",
		year: 1934,
		opening: "(D51) Queen's Gambit Declined",
		nbMoves: 50,
		score: "0-1",
		finalPosition: "/positions/1008008.png"
	},
	{
		title: "F Bohatirchuk vs L Savitsky no name",
		chessgameid: 1240066,
		player1: "F Bohatirchuk",
		player2: "L Savitsky",
		year: 1934,
		opening: "(C78) Ruy Lopez",
		nbMoves: 28,
		score: "0-1",
		finalPosition: "/positions/1240066.png"
	},
	{
		title: "Chekhover vs Kasparian no name",
		chessgameid: 1384082,
		player1: "Chekhover",
		player2: "Kasparian",
		year: 1936,
		opening: "(E67) King's Indian, Fianchetto",
		nbMoves: 33,
		score: "0-1",
		finalPosition: "/positions/1384082.png"
	},
	{
		title: "Tisdall vs G D Lee no name",
		chessgameid: 1282938,
		player1: "Tisdall",
		player2: "G D Lee",
		year: 1981,
		opening: "(B40) Sicilian",
		nbMoves: 19,
		score: "1-0",
		finalPosition: "/positions/1282938.png"
	},
	{
		title: "Fischer vs Mecking no name",
		chessgameid: 1044318,
		player1: "Fischer",
		player2: "Mecking",
		year: 1970,
		opening: "(A01) Nimzovich-Larsen Attack",
		nbMoves: 42,
		score: "1-0",
		finalPosition: "/positions/1044318.png"
	},
	{
		title: "K Georgiev vs Miles no name",
		chessgameid: 1098271,
		player1: "K Georgiev",
		player2: "Miles",
		year: 1992,
		opening: "(B00) Uncommon King's Pawn Opening",
		nbMoves: 38,
		score: "1-0",
		finalPosition: "/positions/1098271.png"
	},
	{
		title: "Kasparov vs Andersson no name",
		chessgameid: 1069976,
		player1: "Kasparov",
		player2: "Andersson",
		year: 1981,
		opening: "(E12) Queen's Indian",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1069976.png"
	},
	{
		title: "Kasparov vs Karpov no name",
		chessgameid: 1067057,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1992,
		opening: "(B17) Caro-Kann, Steinitz Variation",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1067057.png"
	},
	{
		title: "Spassky vs Fischer no name",
		chessgameid: 1044727,
		player1: "Spassky",
		player2: "Fischer",
		year: 1972,
		opening: "(A61) Benoni",
		nbMoves: 41,
		score: "0-1",
		finalPosition: "/positions/1044727.png"
	},
	{
		title: "Kasparov vs Karpov no name",
		chessgameid: 1067288,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1990,
		opening: "(C45) Scotch Game",
		nbMoves: 102,
		score: "1-0",
		finalPosition: "/positions/1067288.png"
	},
	{
		title: "Keene vs Robatsch no name",
		chessgameid: 1071316,
		player1: "Keene",
		player2: "Robatsch",
		year: 1971,
		opening: "(E08) Catalan, Closed",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1071316.png"
	},
	{
		title: "P Ofstad vs Uhlmann no name",
		chessgameid: 1144211,
		player1: "P Ofstad",
		player2: "Uhlmann",
		year: 1963,
		opening: "(C07) French, Tarrasch",
		nbMoves: 19,
		score: "1-0",
		finalPosition: "/positions/1144211.png"
	},
	{
		title: "Motylev vs Bu Xiangzhi no name",
		chessgameid: 1351975,
		player1: "Motylev",
		player2: "Bu Xiangzhi",
		year: 2005,
		opening: "(B90) Sicilian, Najdorf",
		nbMoves: 34,
		score: "0-1",
		finalPosition: "/positions/1351975.png"
	},
	{
		title: "Shirov vs Kasparov no name",
		chessgameid: 1070591,
		player1: "Shirov",
		player2: "Kasparov",
		year: 1992,
		opening: "(E86) King's Indian, Samisch, Orthodox, 7.Nge2 c6",
		nbMoves: 40,
		score: "0-1",
		finalPosition: "/positions/1070591.png"
	},
	{
		title: "Lputian vs Kasparov no name",
		chessgameid: 1069599,
		player1: "Lputian",
		player2: "Kasparov",
		year: 1976,
		opening: "(E80) King's Indian, Samisch Variation",
		nbMoves: 38,
		score: "0-1",
		finalPosition: "/positions/1069599.png"
	},
	{
		title: "M Lowcki vs Tartakower no name",
		chessgameid: 1295503,
		player1: "M Lowcki",
		player2: "Tartakower",
		year: 1937,
		opening: "(C41) Philidor Defense",
		nbMoves: 39,
		score: "0-1",
		finalPosition: "/positions/1295503.png"
	},
	{
		title: "Keene vs S Kerr no name",
		chessgameid: 1290337,
		player1: "Keene",
		player2: "S Kerr",
		year: 1979,
		opening: "(E45) Nimzo-Indian, 4.e3, Bronstein (Byrne) Variation",
		nbMoves: 22,
		score: "1-0",
		finalPosition: "/positions/1290337.png"
	},
	{
		title: "Kasparov vs Karpov no name",
		chessgameid: 1067283,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1990,
		opening: "(C92) Ruy Lopez, Closed",
		nbMoves: 44,
		score: "1-0",
		finalPosition: "/positions/1067283.png"
	},
	{
		title: "J F Barry vs Pillsbury no name",
		chessgameid: 1109053,
		player1: "J F Barry",
		player2: "Pillsbury",
		year: 1899,
		opening: "(C65) Ruy Lopez, Berlin Defense",
		nbMoves: 44,
		score: "1-0",
		finalPosition: "/positions/1109053.png"
	},
	{
		title: "Smyslov vs Liberzon no name",
		chessgameid: 1126259,
		player1: "Smyslov",
		player2: "Liberzon",
		year: 1969,
		opening: "(A10) English",
		nbMoves: 32,
		score: "1-0",
		finalPosition: "/positions/1126259.png"
	},
	{
		title: "Tal vs Leonov no name",
		chessgameid: 1139126,
		player1: "Tal",
		player2: "Leonov",
		year: 1949,
		opening: "(B13) Caro-Kann, Exchange",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1139126.png"
	},
	{
		title: "L Day vs Suttles no name",
		chessgameid: 1037402,
		player1: "L Day",
		player2: "Suttles",
		year: 1969,
		opening: "(A41) Queen's Pawn Game (with ...d6)",
		nbMoves: 40,
		score: "1-0",
		finalPosition: "/positions/1037402.png"
	},
	{
		title: "Ed. Lasker vs B Winkelman no name",
		chessgameid: 1242921,
		player1: "Ed. Lasker",
		player2: "B Winkelman",
		year: 1926,
		opening: "(D60) Queen's Gambit Declined, Orthodox Defense",
		nbMoves: 19,
		score: "1-0",
		finalPosition: "/positions/1242921.png"
	},
	{
		title: "Lilienthal vs R Nezhmetdinov no name",
		chessgameid: 1102154,
		player1: "Lilienthal",
		player2: "R Nezhmetdinov",
		year: 1951,
		opening: "(A54) Old Indian, Ukrainian Variation, 4.Nf3",
		nbMoves: 28,
		score: "0-1",
		finalPosition: "/positions/1102154.png"
	},
	{
		title: "Maczynski vs W H Pratten no name",
		chessgameid: 1242961,
		player1: "Maczynski",
		player2: "W H Pratten",
		year: 1948,
		opening: "(C53) Giuoco Piano",
		nbMoves: 22,
		score: "0-1",
		finalPosition: "/positions/1242961.png"
	},
	{
		title: "Capablanca vs K Treybal no name",
		chessgameid: 1066825,
		player1: "Capablanca",
		player2: "K Treybal",
		year: 1929,
		opening: "(D11) Queen's Gambit Declined Slav",
		nbMoves: 58,
		score: "1-0",
		finalPosition: "/positions/1066825.png"
	},
	{
		title: "Marshall vs Capablanca no name",
		chessgameid: 1094832,
		player1: "Marshall",
		player2: "Capablanca",
		year: 1909,
		opening: "(D33) Queen's Gambit Declined, Tarrasch",
		nbMoves: 49,
		score: "0-1",
		finalPosition: "/positions/1094832.png"
	},
	{
		title: "H Olafsson vs J Levitt no name",
		chessgameid: 1316413,
		player1: "H Olafsson",
		player2: "J Levitt",
		year: 1990,
		opening: "(A30) English, Symmetrical",
		nbMoves: 28,
		score: "1-0",
		finalPosition: "/positions/1316413.png"
	},
	{
		title: "Lutikov vs Velimirovic no name",
		chessgameid: 1266942,
		player1: "Lutikov",
		player2: "Velimirovic",
		year: 1966,
		opening: "(A46) Queen's Pawn Game",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1266942.png"
	},
	{
		title: "Fischer vs Portisch no name",
		chessgameid: 1044249,
		player1: "Fischer",
		player2: "Portisch",
		year: 1966,
		opening: "(C69) Ruy Lopez, Exchange, Gligoric Variation",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1044249.png"
	},
	{
		title: "Averbakh vs Korchnoi no name",
		chessgameid: 1081648,
		player1: "Averbakh",
		player2: "Korchnoi",
		year: 1965,
		opening: "(A49) King's Indian, Fianchetto without c4",
		nbMoves: 39,
		score: "0-1",
		finalPosition: "/positions/1081648.png"
	},
	{
		title: "Velimirovic vs Csom no name",
		chessgameid: 1291226,
		player1: "Velimirovic",
		player2: "Csom",
		year: 1974,
		opening: "(B90) Sicilian, Najdorf",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1291226.png"
	},
	{
		title: "M Szigeti vs Benko no name",
		chessgameid: 1284178,
		player1: "M Szigeti",
		player2: "Benko",
		year: 1945,
		opening: "(D44) Queen's Gambit Declined Semi-Slav",
		nbMoves: 38,
		score: "0-1",
		finalPosition: "/positions/1284178.png"
	},
	{
		title: "Tal vs Portisch no name",
		chessgameid: 1113164,
		player1: "Tal",
		player2: "Portisch",
		year: 1965,
		opening: "(B10) Caro-Kann",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1113164.png"
	},
	{
		title: "Ivkov vs Portisch no name",
		chessgameid: 1061663,
		player1: "Ivkov",
		player2: "Portisch",
		year: 1961,
		opening: "(C18) French, Winawer",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1061663.png"
	},
	{
		title: "Fischer vs U Geller no name",
		chessgameid: 1044281,
		player1: "Fischer",
		player2: "U Geller",
		year: 1968,
		opening: "(A07) King's Indian Attack",
		nbMoves: 32,
		score: "1-0",
		finalPosition: "/positions/1044281.png"
	},
	{
		title: "Pachman vs O Neikirch no name",
		chessgameid: 1104888,
		player1: "Pachman",
		player2: "O Neikirch",
		year: 1958,
		opening: "(D41) Queen's Gambit Declined, Semi-Tarrasch",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1104888.png"
	},
	{
		title: "Pachman vs Fischer no name",
		chessgameid: 1044493,
		player1: "Pachman",
		player2: "Fischer",
		year: 1959,
		opening: "(E10) Queen's Pawn Game",
		nbMoves: 40,
		score: "1-0",
		finalPosition: "/positions/1044493.png"
	},
	{
		title: "Tal vs Simagin no name",
		chessgameid: 1125166,
		player1: "Tal",
		player2: "Simagin",
		year: 1956,
		opening: "(B07) Pirc",
		nbMoves: 45,
		score: "1-0",
		finalPosition: "/positions/1125166.png"
	},
	{
		title: "Pachman vs Eckert no name",
		chessgameid: 1104680,
		player1: "Pachman",
		player2: "Eckert",
		year: 1940,
		opening: "(C13) French",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1104680.png"
	},
	{
		title: "Kasparov vs P Nikolic no name",
		chessgameid: 1070629,
		player1: "Kasparov",
		player2: "P Nikolic",
		year: 1992,
		opening: "(D10) Queen's Gambit Declined Slav",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1070629.png"
	},
	{
		title: "Kasparov vs Wahls no name",
		chessgameid: 1070568,
		player1: "Kasparov",
		player2: "Wahls",
		year: 1992,
		opening: "(B07) Pirc",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1070568.png"
	},
	{
		title: "Lasker vs Capablanca no name",
		chessgameid: 1241504,
		player1: "Lasker",
		player2: "Capablanca",
		year: 1921,
		opening: "(D61) Queen's Gambit Declined, Orthodox, Rubinstein Attack",
		nbMoves: 68,
		score: "0-1",
		finalPosition: "/positions/1241504.png"
	},
	{
		title: "Kasparov vs Gelfand no name",
		chessgameid: 1048116,
		player1: "Kasparov",
		player2: "Gelfand",
		year: 1991,
		opening: "(D45) Queen's Gambit Declined Semi-Slav",
		nbMoves: 38,
		score: "1-0",
		finalPosition: "/positions/1048116.png"
	},
	{
		title: "Psakhis vs Kasparov no name",
		chessgameid: 1070513,
		player1: "Psakhis",
		player2: "Kasparov",
		year: 1990,
		opening: "(A10) English",
		nbMoves: 30,
		score: "0-1",
		finalPosition: "/positions/1070513.png"
	},
	{
		title: "Ivanchuk vs Kasparov no name",
		chessgameid: 1060119,
		player1: "Ivanchuk",
		player2: "Kasparov",
		year: 1990,
		opening: "(B97) Sicilian, Najdorf",
		nbMoves: 46,
		score: "0-1",
		finalPosition: "/positions/1060119.png"
	},
	{
		title: "Kasparov vs Pribyl no name",
		chessgameid: 1069896,
		player1: "Kasparov",
		player2: "Pribyl",
		year: 1980,
		opening: "(D85) Grunfeld",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1069896.png"
	},
	{
		title: "Ljubojevic vs Kasparov no name",
		chessgameid: 1070487,
		player1: "Ljubojevic",
		player2: "Kasparov",
		year: 1989,
		opening: "(B96) Sicilian, Najdorf",
		nbMoves: 37,
		score: "0-1",
		finalPosition: "/positions/1070487.png"
	},
	{
		title: "Kasparov vs Gheorghiu no name",
		chessgameid: 1070019,
		player1: "Kasparov",
		player2: "Gheorghiu",
		year: 1982,
		opening: "(E12) Queen's Indian",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1070019.png"
	},
	{
		title: "Piket vs Kasparov no name",
		chessgameid: 1070485,
		player1: "Piket",
		player2: "Kasparov",
		year: 1989,
		opening: "(E99) King's Indian, Orthodox, Taimanov",
		nbMoves: 28,
		score: "0-1",
		finalPosition: "/positions/1070485.png"
	},
	{
		title: "Kasparov vs Salov no name",
		chessgameid: 1070415,
		player1: "Kasparov",
		player2: "Salov",
		year: 1989,
		opening: "(A15) English",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1070415.png"
	},
	{
		title: "Yusupov vs Kasparov no name",
		chessgameid: 1070408,
		player1: "Yusupov",
		player2: "Kasparov",
		year: 1989,
		opening: "(E92) King's Indian",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1070408.png"
	},
	{
		title: "Speelman vs Kasparov no name",
		chessgameid: 1070446,
		player1: "Speelman",
		player2: "Kasparov",
		year: 1988,
		opening: "(E92) King's Indian",
		nbMoves: 39,
		score: "0-1",
		finalPosition: "/positions/1070446.png"
	},
	{
		title: "Ehlvest vs Kasparov no name",
		chessgameid: 1070382,
		player1: "Ehlvest",
		player2: "Kasparov",
		year: 1988,
		opening: "(A28) English",
		nbMoves: 25,
		score: "0-1",
		finalPosition: "/positions/1070382.png"
	},
	{
		title: "Timman vs Kasparov no name",
		chessgameid: 1070378,
		player1: "Timman",
		player2: "Kasparov",
		year: 1988,
		opening: "(E88) King's Indian, Samisch, Orthodox, 7.d5 c6",
		nbMoves: 45,
		score: "0-1",
		finalPosition: "/positions/1070378.png"
	},
	{
		title: "Kasparov vs Ivanchuk no name",
		chessgameid: 1070341,
		player1: "Kasparov",
		player2: "Ivanchuk",
		year: 1988,
		opening: "(A29) English, Four Knights, Kingside Fianchetto",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1070341.png"
	},
	{
		title: "Kasparov vs A Sokolov no name",
		chessgameid: 1070307,
		player1: "Kasparov",
		player2: "A Sokolov",
		year: 1988,
		opening: "(A19) English, Mikenas-Carls, Sicilian Variation",
		nbMoves: 42,
		score: "1-0",
		finalPosition: "/positions/1070307.png"
	},
	{
		title: "Kasparov vs Andersson no name",
		chessgameid: 1070305,
		player1: "Kasparov",
		player2: "Andersson",
		year: 1988,
		opening: "(D36) Queen's Gambit Declined, Exchange, Positional line, 6.Qc2",
		nbMoves: 38,
		score: "1-0",
		finalPosition: "/positions/1070305.png"
	},
	{
		title: "Kasparov vs Karpov no name",
		chessgameid: 1067027,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1988,
		opening: "(B17) Caro-Kann, Steinitz Variation",
		nbMoves: 63,
		score: "1-0",
		finalPosition: "/positions/1067027.png"
	},
	{
		title: "Kasparov vs Karpov no name",
		chessgameid: 1067242,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1987,
		opening: "(A13) English",
		nbMoves: 64,
		score: "1-0",
		finalPosition: "/positions/1067242.png"
	},
	{
		title: "Kasparov vs Karpov no name",
		chessgameid: 1067247,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1987,
		opening: "(A21) English",
		nbMoves: 50,
		score: "1-0",
		finalPosition: "/positions/1067247.png"
	},
	{
		title: "Kasparov vs Tal no name",
		chessgameid: 1070236,
		player1: "Kasparov",
		player2: "Tal",
		year: 1987,
		opening: "(E48) Nimzo-Indian, 4.e3 O-O 5.Bd3 d5",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1070236.png"
	},
	{
		title: "Kasparov vs Karpov no name",
		chessgameid: 1067214,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1986,
		opening: "(D55) Queen's Gambit Declined",
		nbMoves: 46,
		score: "1-0",
		finalPosition: "/positions/1067214.png"
	},
	{
		title: "Tal vs A Vooremaa no name",
		chessgameid: 1140006,
		player1: "Tal",
		player2: "A Vooremaa",
		year: 1971,
		opening: "(B48) Sicilian, Taimanov Variation",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1140006.png"
	},
	{
		title: "Karpov vs Kasparov no name",
		chessgameid: 1067179,
		player1: "Karpov",
		player2: "Kasparov",
		year: 1985,
		opening: "(B84) Sicilian, Scheveningen",
		nbMoves: 42,
		score: "0-1",
		finalPosition: "/positions/1067179.png"
	},
	{
		title: "Kasparov vs Karpov no name",
		chessgameid: 1067136,
		player1: "Kasparov",
		player2: "Karpov",
		year: 1984,
		opening: "(E12) Queen's Indian",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1067136.png"
	},
	{
		title: "Malinin vs A Andreev no name",
		chessgameid: 1039163,
		player1: "Malinin",
		player2: "A Andreev",
		year: 1989,
		opening: "(A58) Benko Gambit",
		nbMoves: 32,
		score: "1-0",
		finalPosition: "/positions/1039163.png"
	},
	{
		title: "Tal vs M Pasman no name",
		chessgameid: 1139189,
		player1: "Tal",
		player2: "M Pasman",
		year: 1953,
		opening: "(B93) Sicilian, Najdorf, 6.f4",
		nbMoves: 40,
		score: "1-0",
		finalPosition: "/positions/1139189.png"
	},
	{
		title: "Nakamura vs Pelletier no name",
		chessgameid: 1349054,
		player1: "Nakamura",
		player2: "Pelletier",
		year: 2005,
		opening: "(C02) French, Advance",
		nbMoves: 52,
		score: "1-0",
		finalPosition: "/positions/1349054.png"
	},
	{
		title: "Anand vs Ivanchuk no name",
		chessgameid: 1060709,
		player1: "Anand",
		player2: "Ivanchuk",
		year: 1996,
		opening: "(C78) Ruy Lopez",
		nbMoves: 46,
		score: "1-0",
		finalPosition: "/positions/1060709.png"
	},
	{
		title: "Brzozka vs Bronstein no name",
		chessgameid: 1262289,
		player1: "Brzozka",
		player2: "Bronstein",
		year: 1963,
		opening: "(A88) Dutch, Leningrad, Main Variation with c6",
		nbMoves: 70,
		score: "0-1",
		finalPosition: "/positions/1262289.png"
	},
	{
		title: "Topalov vs Shirov no name",
		chessgameid: 1143956,
		player1: "Topalov",
		player2: "Shirov",
		year: 1998,
		opening: "(D85) Grunfeld",
		nbMoves: 53,
		score: "0-1",
		finalPosition: "/positions/1143956.png"
	},
	{
		title: "Granda Zuniga vs Seirawan no name",
		chessgameid: 1052923,
		player1: "Granda Zuniga",
		player2: "Seirawan",
		year: 1993,
		opening: "(A15) English",
		nbMoves: 56,
		score: "1-0",
		finalPosition: "/positions/1052923.png"
	},
	{
		title: "Karpov vs Huebner no name",
		chessgameid: 1066997,
		player1: "Karpov",
		player2: "Huebner",
		year: 1982,
		opening: "(B18) Caro-Kann, Classical",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1066997.png"
	},
	{
		title: "Kamsky vs Polgar no name",
		chessgameid: 1066762,
		player1: "Kamsky",
		player2: "Polgar",
		year: 1994,
		opening: "(B45) Sicilian, Taimanov",
		nbMoves: 38,
		score: "0-1",
		finalPosition: "/positions/1066762.png"
	},
	{
		title: "Gligoric vs Stein no name",
		chessgameid: 1282672,
		player1: "Gligoric",
		player2: "Stein",
		year: 1962,
		opening: "(E70) King's Indian",
		nbMoves: 57,
		score: "0-1",
		finalPosition: "/positions/1282672.png"
	},
	{
		title: "Yermolinsky vs L Christiansen no name",
		chessgameid: 1399208,
		player1: "Yermolinsky",
		player2: "L Christiansen",
		year: 2006,
		opening: "(E10) Queen's Pawn Game",
		nbMoves: 30,
		score: "0-1",
		finalPosition: "/positions/1399208.png"
	},
	{
		title: "Kramnik vs Shirov no name",
		chessgameid: 1085871,
		player1: "Kramnik",
		player2: "Shirov",
		year: 1994,
		opening: "(D02) Queen's Pawn Game",
		nbMoves: 43,
		score: "0-1",
		finalPosition: "/positions/1085871.png"
	},
	{
		title: "Timman vs Kasparov no name",
		chessgameid: 1070170,
		player1: "Timman",
		player2: "Kasparov",
		year: 1985,
		opening: "(C93) Ruy Lopez, Closed, Smyslov Defense",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1070170.png"
	},
	{
		title: "Bronstein vs E Rojahn no name",
		chessgameid: 1033954,
		player1: "Bronstein",
		player2: "E Rojahn",
		year: 1956,
		opening: "(C58) Two Knights",
		nbMoves: 38,
		score: "1-0",
		finalPosition: "/positions/1033954.png"
	},
	{
		title: "Taimanov vs Larsen no name",
		chessgameid: 1138444,
		player1: "Taimanov",
		player2: "Larsen",
		year: 1970,
		opening: "(E39) Nimzo-Indian, Classical, Pirc Variation",
		nbMoves: 34,
		score: "0-1",
		finalPosition: "/positions/1138444.png"
	},
	{
		title: "Keres vs D Byrne no name",
		chessgameid: 1073400,
		player1: "Keres",
		player2: "D Byrne",
		year: 1972,
		opening: "(D94) Grunfeld",
		nbMoves: 33,
		score: "1-0",
		finalPosition: "/positions/1073400.png"
	},
	{
		title: "Euwe vs Alekhine no name",
		chessgameid: 1013094,
		player1: "Euwe",
		player2: "Alekhine",
		year: 1935,
		opening: "(D81) Grunfeld, Russian Variation",
		nbMoves: 45,
		score: "1-0",
		finalPosition: "/positions/1013094.png"
	},
	{
		title: "Kamsky vs Karpov no name",
		chessgameid: 1066717,
		player1: "Kamsky",
		player2: "Karpov",
		year: 1993,
		opening: "(B17) Caro-Kann, Steinitz Variation",
		nbMoves: 49,
		score: "0-1",
		finalPosition: "/positions/1066717.png"
	},
	{
		title: "Karpov vs Csom no name",
		chessgameid: 1067981,
		player1: "Karpov",
		player2: "Csom",
		year: 1977,
		opening: "(A16) English",
		nbMoves: 50,
		score: "1-0",
		finalPosition: "/positions/1067981.png"
	},
	{
		title: "Browne vs Bisguier no name",
		chessgameid: 1028581,
		player1: "Browne",
		player2: "Bisguier",
		year: 1974,
		opening: "(C42) Petrov Defense",
		nbMoves: 40,
		score: "1-0",
		finalPosition: "/positions/1028581.png"
	},
	{
		title: "Anderssen vs Morphy no name",
		chessgameid: 1019054,
		player1: "Anderssen",
		player2: "Morphy",
		year: 1858,
		opening: "(C77) Ruy Lopez",
		nbMoves: 51,
		score: "0-1",
		finalPosition: "/positions/1019054.png"
	},
	{
		title: "Keres vs K Richter no name",
		chessgameid: 1072028,
		player1: "Keres",
		player2: "K Richter",
		year: 1942,
		opening: "(A28) English",
		nbMoves: 59,
		score: "0-1",
		finalPosition: "/positions/1072028.png"
	},
	{
		title: "J Klavins vs Tal no name",
		chessgameid: 1139462,
		player1: "J Klavins",
		player2: "Tal",
		year: 1959,
		opening: "(B99) Sicilian, Najdorf, 7...Be7 Main line",
		nbMoves: 45,
		score: "0-1",
		finalPosition: "/positions/1139462.png"
	},
	{
		title: "Tal vs Lisitsin no name",
		chessgameid: 1139306,
		player1: "Tal",
		player2: "Lisitsin",
		year: 1956,
		opening: "(B71) Sicilian, Dragon, Levenfish Variation",
		nbMoves: 54,
		score: "1-0",
		finalPosition: "/positions/1139306.png"
	},
	{
		title: "Botvinnik vs Reshevsky no name",
		chessgameid: 1032174,
		player1: "Botvinnik",
		player2: "Reshevsky",
		year: 1948,
		opening: "(E29) Nimzo-Indian, Samisch",
		nbMoves: 42,
		score: "0-1",
		finalPosition: "/positions/1032174.png"
	},
	{
		title: "Capablanca vs M Fonaroff no name",
		chessgameid: 1265585,
		player1: "Capablanca",
		player2: "M Fonaroff",
		year: 1918,
		opening: "(C66) Ruy Lopez",
		nbMoves: 22,
		score: "1-0",
		finalPosition: "/positions/1265585.png"
	},
	{
		title: "M Lazarevic vs N Gaprindashvili no name",
		chessgameid: 1270326,
		player1: "M Lazarevic",
		player2: "N Gaprindashvili",
		year: 1961,
		opening: "(A02) Bird's Opening",
		nbMoves: 33,
		score: "0-1",
		finalPosition: "/positions/1270326.png"
	},
	{
		title: "Szabo vs G Sigurjonsson no name",
		chessgameid: 1137380,
		player1: "Szabo",
		player2: "G Sigurjonsson",
		year: 1968,
		opening: "(D47) Queen's Gambit Declined Semi-Slav",
		nbMoves: 40,
		score: "0-1",
		finalPosition: "/positions/1137380.png"
	},
	{
		title: "H J Cordes vs Miles no name",
		chessgameid: 1097651,
		player1: "H J Cordes",
		player2: "Miles",
		year: 1985,
		opening: "(E21) Nimzo-Indian, Three Knights",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1097651.png"
	},
	{
		title: "A Ostapenko vs S Kurkin no name",
		chessgameid: 1306168,
		player1: "A Ostapenko",
		player2: "S Kurkin",
		year: 1970,
		opening: "(B82) Sicilian, Scheveningen",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1306168.png"
	},
	{
		title: "F Catheley vs M Hadzikaric no name",
		chessgameid: 1286111,
		player1: "F Catheley",
		player2: "M Hadzikaric",
		year: 1995,
		opening: "(A10) English",
		nbMoves: 31,
		score: "0-1",
		finalPosition: "/positions/1286111.png"
	},
	{
		title: "A Shashin vs Korchnoi no name",
		chessgameid: 1082235,
		player1: "A Shashin",
		player2: "Korchnoi",
		year: 1973,
		opening: "(E56) Nimzo-Indian, 4.e3, Main line with 7...Nc6",
		nbMoves: 35,
		score: "1-0",
		finalPosition: "/positions/1082235.png"
	},
	{
		title: "V Ruban vs A Poluljahov no name",
		chessgameid: 1266676,
		player1: "V Ruban",
		player2: "A Poluljahov",
		year: 1994,
		opening: "(E94) King's Indian, Orthodox",
		nbMoves: 28,
		score: "1-0",
		finalPosition: "/positions/1266676.png"
	},
	{
		title: "J Cukierman vs Tartakower no name",
		chessgameid: 1328978,
		player1: "J Cukierman",
		player2: "Tartakower",
		year: 1930,
		opening: "(A47) Queen's Indian",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1328978.png"
	},
	{
		title: "J Cukierman vs A Voisin no name",
		chessgameid: 1306150,
		player1: "J Cukierman",
		player2: "A Voisin",
		year: 1928,
		opening: "(D02) Queen's Pawn Game",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1306150.png"
	},
	{
		title: "P Moran Santamaria vs E Franco Raymundo no name",
		chessgameid: 1284185,
		player1: "P Moran Santamaria",
		player2: "E Franco Raymundo",
		year: 1955,
		opening: "(B64) Sicilian, Richter-Rauzer Attack",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1284185.png"
	},
	{
		title: "Ni Hua vs M Mchedlishvili no name",
		chessgameid: 1366526,
		player1: "Ni Hua",
		player2: "M Mchedlishvili",
		year: 2005,
		opening: "(E29) Nimzo-Indian, Samisch",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1366526.png"
	},
	{
		title: "Alatortsev vs Boleslavsky no name",
		chessgameid: 1262416,
		player1: "Alatortsev",
		player2: "Boleslavsky",
		year: 1950,
		opening: "(A54) Old Indian, Ukrainian Variation, 4.Nf3",
		nbMoves: 27,
		score: "0-1",
		finalPosition: "/positions/1262416.png"
	},
	{
		title: "Gurgenidze vs Tal no name",
		chessgameid: 1139346,
		player1: "Gurgenidze",
		player2: "Tal",
		year: 1957,
		opening: "(A78) Benoni, Classical with ...Re8 and ...Na6",
		nbMoves: 27,
		score: "0-1",
		finalPosition: "/positions/1139346.png"
	},
	{
		title: "N Bakulin vs Bronstein no name",
		chessgameid: 1034335,
		player1: "N Bakulin",
		player2: "Bronstein",
		year: 1965,
		opening: "(B16) Caro-Kann, Bronstein-Larsen Variation",
		nbMoves: 32,
		score: "0-1",
		finalPosition: "/positions/1034335.png"
	},
	{
		title: "Tal vs G Fuster no name",
		chessgameid: 1139404,
		player1: "Tal",
		player2: "G Fuster",
		year: 1958,
		opening: "(B17) Caro-Kann, Steinitz Variation",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1139404.png"
	},
	{
		title: "Fischer vs O Celle no name",
		chessgameid: 1255208,
		player1: "Fischer",
		player2: "O Celle",
		year: 1964,
		opening: "(C51) Evans Gambit",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1255208.png"
	},
	{
		title: "Tal vs J H Donner no name",
		chessgameid: 1139881,
		player1: "Tal",
		player2: "J H Donner",
		year: 1968,
		opening: "(C18) French, Winawer",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1139881.png"
	},
	{
		title: "Kavalek vs Matulovic no name",
		chessgameid: 1266941,
		player1: "Kavalek",
		player2: "Matulovic",
		year: 1966,
		opening: "(A57) Benko Gambit",
		nbMoves: 32,
		score: "1-0",
		finalPosition: "/positions/1266941.png"
	},
	{
		title: "E Nikolic vs Fischer no name",
		chessgameid: 1044654,
		player1: "E Nikolic",
		player2: "Fischer",
		year: 1968,
		opening: "(A10) English",
		nbMoves: 31,
		score: "0-1",
		finalPosition: "/positions/1044654.png"
	},
	{
		title: "V Kozomara vs R Byrne no name",
		chessgameid: 1153948,
		player1: "V Kozomara",
		player2: "R Byrne",
		year: 1967,
		opening: "(A00) Uncommon Opening",
		nbMoves: 38,
		score: "0-1",
		finalPosition: "/positions/1153948.png"
	},
	{
		title: "Polugaevsky vs Petrosian no name",
		chessgameid: 1106473,
		player1: "Polugaevsky",
		player2: "Petrosian",
		year: 1960,
		opening: "(E54) Nimzo-Indian, 4.e3, Gligoric System",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1106473.png"
	},
	{
		title: "Evans vs Bisguier no name",
		chessgameid: 1028397,
		player1: "Evans",
		player2: "Bisguier",
		year: 1958,
		opening: "(C42) Petrov Defense",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1028397.png"
	},
	{
		title: "Smejkal vs Smyslov no name",
		chessgameid: 1224539,
		player1: "Smejkal",
		player2: "Smyslov",
		year: 1969,
		opening: "(B06) Robatsch",
		nbMoves: 32,
		score: "1-0",
		finalPosition: "/positions/1224539.png"
	},
	{
		title: "Keres vs Geller no name",
		chessgameid: 1049065,
		player1: "Keres",
		player2: "Geller",
		year: 1962,
		opening: "(D41) Queen's Gambit Declined, Semi-Tarrasch",
		nbMoves: 28,
		score: "1-0",
		finalPosition: "/positions/1049065.png"
	},
	{
		title: "Benko vs I A Horowitz no name",
		chessgameid: 1056942,
		player1: "Benko",
		player2: "I A Horowitz",
		year: 1968,
		opening: "(A12) English with b3",
		nbMoves: 20,
		score: "1-0",
		finalPosition: "/positions/1056942.png"
	},
	{
		title: "Tal vs Gligoric no name",
		chessgameid: 1139848,
		player1: "Tal",
		player2: "Gligoric",
		year: 1968,
		opening: "(C93) Ruy Lopez, Closed, Smyslov Defense",
		nbMoves: 46,
		score: "0-1",
		finalPosition: "/positions/1139848.png"
	},
	{
		title: "Ivkov vs J H Donner no name",
		chessgameid: 1061789,
		player1: "Ivkov",
		player2: "J H Donner",
		year: 1965,
		opening: "(C81) Ruy Lopez, Open, Howell Attack",
		nbMoves: 21,
		score: "1-0",
		finalPosition: "/positions/1061789.png"
	},
	{
		title: "Tal vs E Nievergelt no name",
		chessgameid: 1139492,
		player1: "Tal",
		player2: "E Nievergelt",
		year: 1959,
		opening: "(B63) Sicilian, Richter-Rauzer Attack",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1139492.png"
	},
	{
		title: "Tal vs Bolbochan no name",
		chessgameid: 1031329,
		player1: "Tal",
		player2: "Bolbochan",
		year: 1966,
		opening: "(B89) Sicilian",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1031329.png"
	},
	{
		title: "Fischer vs P Dely no name",
		chessgameid: 1044262,
		player1: "Fischer",
		player2: "P Dely",
		year: 1967,
		opening: "(B88) Sicilian, Fischer-Sozin Attack",
		nbMoves: 17,
		score: "1-0",
		finalPosition: "/positions/1044262.png"
	},
	{
		title: "Fischer vs Benko no name",
		chessgameid: 1008387,
		player1: "Fischer",
		player2: "Benko",
		year: 1959,
		opening: "(B57) Sicilian",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1008387.png"
	},
	{
		title: "A strategic masterpiece",
		chessgameid: 1037801,
		player1: "L Day",
		player2: "T Koliada",
		year: 1994,
		opening: "(A07) King's Indian Attack",
		nbMoves: 48,
		score: "1-0",
		finalPosition: "/positions/1037801.png"
	},
	{
		title: "Tal vs F Olafsson no name",
		chessgameid: 1139536,
		player1: "Tal",
		player2: "F Olafsson",
		year: 1961,
		opening: "(B48) Sicilian, Taimanov Variation",
		nbMoves: 38,
		score: "1-0",
		finalPosition: "/positions/1139536.png"
	},
	{
		title: "Stein vs Portisch no name",
		chessgameid: 1112976,
		player1: "Stein",
		player2: "Portisch",
		year: 1962,
		opening: "(B42) Sicilian, Kan",
		nbMoves: 21,
		score: "1-0",
		finalPosition: "/positions/1112976.png"
	},
	{
		title: "Spassky vs Suetin no name",
		chessgameid: 1134796,
		player1: "Spassky",
		player2: "Suetin",
		year: 1967,
		opening: "(B48) Sicilian, Taimanov Variation",
		nbMoves: 59,
		score: "1-0",
		finalPosition: "/positions/1134796.png"
	},
	{
		title: "R Nezhmetdinov vs Tal no name",
		chessgameid: 1102235,
		player1: "R Nezhmetdinov",
		player2: "Tal",
		year: 1961,
		opening: "(B84) Sicilian, Scheveningen",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1102235.png"
	},
	{
		title: "Tal vs Gligoric no name",
		chessgameid: 1139642,
		player1: "Tal",
		player2: "Gligoric",
		year: 1963,
		opening: "(B99) Sicilian, Najdorf, 7...Be7 Main line",
		nbMoves: 43,
		score: "1-0",
		finalPosition: "/positions/1139642.png"
	},
	{
		title: "Fischer vs Bolbochan no name",
		chessgameid: 1031289,
		player1: "Fischer",
		player2: "Bolbochan",
		year: 1962,
		opening: "(B90) Sicilian, Najdorf",
		nbMoves: 37,
		score: "1-0",
		finalPosition: "/positions/1031289.png"
	},
	{
		title: "Larsen vs Petrosian no name",
		chessgameid: 1106678,
		player1: "Larsen",
		player2: "Petrosian",
		year: 1966,
		opening: "(B39) Sicilian, Accelerated Fianchetto, Breyer Variation",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1106678.png"
	},
	{
		title: "Spassky vs Geller no name",
		chessgameid: 1049394,
		player1: "Spassky",
		player2: "Geller",
		year: 1968,
		opening: "(B25) Sicilian, Closed",
		nbMoves: 32,
		score: "1-0",
		finalPosition: "/positions/1049394.png"
	},
	{
		title: "Stanishevsky vs Nikonov no name",
		chessgameid: 1371041,
		player1: "Stanishevsky",
		player2: "Nikonov",
		year: 1981,
		opening: "(B30) Sicilian",
		nbMoves: 33,
		score: "1-0",
		finalPosition: "/positions/1371041.png"
	},
	{
		title: "Navara vs J Helbich no name",
		chessgameid: 1287309,
		player1: "Navara",
		player2: "J Helbich",
		year: 1998,
		opening: "(B99) Sicilian, Najdorf, 7...Be7 Main line",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1287309.png"
	},
	{
		title: "Larsen vs Ljubojevic no name",
		chessgameid: 1091560,
		player1: "Larsen",
		player2: "Ljubojevic",
		year: 1975,
		opening: "(A77) Benoni, Classical, 9...Re8, 10.Nd2",
		nbMoves: 27,
		score: "0-1",
		finalPosition: "/positions/1091560.png"
	},
	{
		title: "T Nielsen vs Thormod Furu no name",
		chessgameid: 1173830,
		player1: "T Nielsen",
		player2: "Thormod Furu",
		year: 2001,
		opening: "(A11) English, Caro-Kann Defensive System",
		nbMoves: 15,
		score: "0-1",
		finalPosition: "/positions/1173830.png"
	},
	{
		title: "Romanishin vs Beliavsky no name",
		chessgameid: 1119108,
		player1: "Romanishin",
		player2: "Beliavsky",
		year: 1993,
		opening: "(C15) French, Winawer",
		nbMoves: 42,
		score: "0-1",
		finalPosition: "/positions/1119108.png"
	},
	{
		title: "Nimzowitsch vs Salwe no name",
		chessgameid: 1000795,
		player1: "Nimzowitsch",
		player2: "Salwe",
		year: 1911,
		opening: "(C02) French, Advance",
		nbMoves: 39,
		score: "1-0",
		finalPosition: "/positions/1000795.png"
	},
	{
		title: "Radjabov vs Shirov no name",
		chessgameid: 1416246,
		player1: "Radjabov",
		player2: "Shirov",
		year: 2006,
		opening: "(C69) Ruy Lopez, Exchange, Gligoric Variation",
		nbMoves: 39,
		score: "1-0",
		finalPosition: "/positions/1416246.png"
	},
	{
		title: "Torre vs M A Schapiro no name",
		chessgameid: 1144009,
		player1: "Torre",
		player2: "M A Schapiro",
		year: 1924,
		opening: "(D30) Queen's Gambit Declined",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1144009.png"
	},
	{
		title: "Torre vs Lasker no name",
		chessgameid: 1100063,
		player1: "Torre",
		player2: "Lasker",
		year: 1925,
		opening: "(A46) Queen's Pawn Game",
		nbMoves: 43,
		score: "1-0",
		finalPosition: "/positions/1100063.png"
	},
	{
		title: "Torre vs B Verlinsky no name",
		chessgameid: 1100115,
		player1: "Torre",
		player2: "B Verlinsky",
		year: 1925,
		opening: "(A47) Queen's Indian",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1100115.png"
	},
	{
		title: "Torre vs F Duz-Khotimirsky no name",
		chessgameid: 1099999,
		player1: "Torre",
		player2: "F Duz-Khotimirsky",
		year: 1925,
		opening: "(D02) Queen's Pawn Game",
		nbMoves: 55,
		score: "1-0",
		finalPosition: "/positions/1099999.png"
	},
	{
		title: "Fine vs A Kevitz no name",
		chessgameid: 1043706,
		player1: "Fine",
		player2: "A Kevitz",
		year: 1932,
		opening: "(A70) Benoni, Classical with 7.Nf3",
		nbMoves: 32,
		score: "1-0",
		finalPosition: "/positions/1043706.png"
	},
	{
		title: "Fine vs Lasker no name",
		chessgameid: 1008316,
		player1: "Fine",
		player2: "Lasker",
		year: 1936,
		opening: "(D37) Queen's Gambit Declined",
		nbMoves: 33,
		score: "1-0",
		finalPosition: "/positions/1008316.png"
	},
	{
		title: "Capablanca vs Manhattan CC no name",
		chessgameid: 1043696,
		player1: "Capablanca",
		player2: "Manhattan CC",
		year: 1931,
		opening: "(D51) Queen's Gambit Declined",
		nbMoves: 48,
		score: "0-1",
		finalPosition: "/positions/1043696.png"
	},
	{
		title: "Kavalek vs W Pietzsch no name",
		chessgameid: 1153943,
		player1: "Kavalek",
		player2: "W Pietzsch",
		year: 1967,
		opening: "(A22) English",
		nbMoves: 30,
		score: "1-0",
		finalPosition: "/positions/1153943.png"
	},
	{
		title: "Wang Yue vs Ponomariov no name",
		chessgameid: 1333187,
		player1: "Wang Yue",
		player2: "Ponomariov",
		year: 2005,
		opening: "(A00) Uncommon Opening",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1333187.png"
	},
	{
		title: "Kramnik vs Kasparov no name",
		chessgameid: 1070716,
		player1: "Kramnik",
		player2: "Kasparov",
		year: 1994,
		opening: "(E93) King's Indian, Petrosian System",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1070716.png"
	},
	{
		title: "Anand vs Bologan no name",
		chessgameid: 1266094,
		player1: "Anand",
		player2: "Bologan",
		year: 2003,
		opening: "(B17) Caro-Kann, Steinitz Variation",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1266094.png"
	},
	{
		title: "Fischer vs Fine no name",
		chessgameid: 1043992,
		player1: "Fischer",
		player2: "Fine",
		year: 1963,
		opening: "(C52) Evans Gambit",
		nbMoves: 17,
		score: "1-0",
		finalPosition: "/positions/1043992.png"
	},
	{
		title: "A Steinkuehler vs Blackburne no name",
		chessgameid: 1028832,
		player1: "A Steinkuehler",
		player2: "Blackburne",
		year: 1863,
		opening: "(C54) Giuoco Piano",
		nbMoves: 22,
		score: "0-1",
		finalPosition: "/positions/1028832.png"
	},
	{
		title: "Chiburdanidze vs V Malaniuk no name",
		chessgameid: 1262417,
		player1: "Chiburdanidze",
		player2: "V Malaniuk",
		year: 1982,
		opening: "(D85) Grunfeld",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1262417.png"
	},
	{
		title: "Lilienthal vs Capablanca no name",
		chessgameid: 1090860,
		player1: "Lilienthal",
		player2: "Capablanca",
		year: 1935,
		opening: "(E24) Nimzo-Indian, Samisch",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1090860.png"
	},
	{
		title: "Karpov vs Topalov no name",
		chessgameid: 1038842,
		player1: "Karpov",
		player2: "Topalov",
		year: 1994,
		opening: "(A43) Old Benoni",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1038842.png"
	},
	{
		title: "Tarrasch vs Marotti / Napoli / de Simone / del no name",
		chessgameid: 1378821,
		player1: "Tarrasch",
		player2: "Marotti / Napoli / de Simone / del",
		year: 1914,
		opening: "(A03) Bird's Opening",
		nbMoves: 31,
		score: "1-0",
		finalPosition: "/positions/1378821.png"
	},
	{
		title: "Reshevsky vs Capablanca no name",
		chessgameid: 1224079,
		player1: "Reshevsky",
		player2: "Capablanca",
		year: 1935,
		opening: "(D51) Queen's Gambit Declined",
		nbMoves: 56,
		score: "1-0",
		finalPosition: "/positions/1224079.png"
	},
	{
		title: "Yakovich vs Bronstein no name",
		chessgameid: 1035115,
		player1: "Yakovich",
		player2: "Bronstein",
		year: 1994,
		opening: "(D26) Queen's Gambit Accepted",
		nbMoves: 22,
		score: "1-0",
		finalPosition: "/positions/1035115.png"
	},
	{
		title: "J Rosanes vs Anderssen no name",
		chessgameid: 1019162,
		player1: "J Rosanes",
		player2: "Anderssen",
		year: 1863,
		opening: "(C39) King's Gambit Accepted",
		nbMoves: 23,
		score: "0-1",
		finalPosition: "/positions/1019162.png"
	},
	{
		title: "Anderssen vs Zukertort no name",
		chessgameid: 1019346,
		player1: "Anderssen",
		player2: "Zukertort",
		year: 1869,
		opening: "(C51) Evans Gambit",
		nbMoves: 29,
		score: "1-0",
		finalPosition: "/positions/1019346.png"
	},
	{
		title: "J Rosanes vs Anderssen no name",
		chessgameid: 1019123,
		player1: "J Rosanes",
		player2: "Anderssen",
		year: 1862,
		opening: "(C31) King's Gambit Declined, Falkbeer Counter Gambit",
		nbMoves: 19,
		score: "0-1",
		finalPosition: "/positions/1019123.png"
	},
	{
		title: "Vitacek vs Duras no name",
		chessgameid: 1286992,
		player1: "Vitacek",
		player2: "Duras",
		year: 1900,
		opening: "(C22) Center Game",
		nbMoves: 26,
		score: "0-1",
		finalPosition: "/positions/1286992.png"
	},
	{
		title: "Spielmann vs R L'hermet no name",
		chessgameid: 1130889,
		player1: "Spielmann",
		player2: "R L'hermet",
		year: 1927,
		opening: "(C10) French",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1130889.png"
	},
	{
		title: "Spielmann vs B Hoenlinger no name",
		chessgameid: 1130925,
		player1: "Spielmann",
		player2: "B Hoenlinger",
		year: 1929,
		opening: "(B15) Caro-Kann",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1130925.png"
	},
	{
		title: "Andersson vs Tal no name",
		chessgameid: 1020244,
		player1: "Andersson",
		player2: "Tal",
		year: 1983,
		opening: "(D55) Queen's Gambit Declined",
		nbMoves: 51,
		score: "1-0",
		finalPosition: "/positions/1020244.png"
	},
	{
		title: "Andersson vs Karpov no name",
		chessgameid: 1020945,
		player1: "Andersson",
		player2: "Karpov",
		year: 1995,
		opening: "(D28) Queen's Gambit Accepted, Classical",
		nbMoves: 18,
		score: "1-0",
		finalPosition: "/positions/1020945.png"
	},
	{
		title: "Ljubojevic vs J Durao no name",
		chessgameid: 1091498,
		player1: "Ljubojevic",
		player2: "J Durao",
		year: 1974,
		opening: "(C64) Ruy Lopez, Classical",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1091498.png"
	},
	{
		title: "Geller vs Averbakh no name",
		chessgameid: 1321911,
		player1: "Geller",
		player2: "Averbakh",
		year: 1954,
		opening: "(A07) King's Indian Attack",
		nbMoves: 46,
		score: "0-1",
		finalPosition: "/positions/1321911.png"
	},
	{
		title: "Nunn vs C Pritchett no name",
		chessgameid: 1103407,
		player1: "Nunn",
		player2: "C Pritchett",
		year: 1986,
		opening: "(B89) Sicilian",
		nbMoves: 27,
		score: "1-0",
		finalPosition: "/positions/1103407.png"
	},
	{
		title: "Shen Yang vs Rublevsky no name",
		chessgameid: 1366582,
		player1: "Shen Yang",
		player2: "Rublevsky",
		year: 2005,
		opening: "(B42) Sicilian, Kan",
		nbMoves: 47,
		score: "1-0",
		finalPosition: "/positions/1366582.png"
	},
	{
		title: "Smyslov vs Ribli no name",
		chessgameid: 1126740,
		player1: "Smyslov",
		player2: "Ribli",
		year: 1983,
		opening: "(D42) Queen's Gambit Declined, Semi-Tarrasch, 7.Bd3",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1126740.png"
	},
	{
		title: "Adams vs V Akopian no name",
		chessgameid: 1290140,
		player1: "Adams",
		player2: "V Akopian",
		year: 2004,
		opening: "(C10) French",
		nbMoves: 25,
		score: "1-0",
		finalPosition: "/positions/1290140.png"
	},
	{
		title: "Petrosian vs Balashov no name",
		chessgameid: 1024306,
		player1: "Petrosian",
		player2: "Balashov",
		year: 1974,
		opening: "(E54) Nimzo-Indian, 4.e3, Gligoric System",
		nbMoves: 28,
		score: "1-0",
		finalPosition: "/positions/1024306.png"
	},
	{
		title: "Gelfand vs Kramnik no name",
		chessgameid: 1302183,
		player1: "Gelfand",
		player2: "Kramnik",
		year: 1994,
		opening: "(C10) French",
		nbMoves: 26,
		score: "1-0",
		finalPosition: "/positions/1302183.png"
	},
	{
		title: "E M Jackson vs Marshall no name",
		chessgameid: 1094456,
		player1: "E M Jackson",
		player2: "Marshall",
		year: 1899,
		opening: "(C24) Bishop's Opening",
		nbMoves: 30,
		score: "0-1",
		finalPosition: "/positions/1094456.png"
	},
	{
		title: "L Christiansen vs Wojtkiewicz no name",
		chessgameid: 1398825,
		player1: "L Christiansen",
		player2: "Wojtkiewicz",
		year: 2006,
		opening: "(B87) Sicilian, Fischer-Sozin with ...a6 and ...b5",
		nbMoves: 23,
		score: "1-0",
		finalPosition: "/positions/1398825.png"
	},
	{
		title: "Gheorghiu vs Kavalek no name",
		chessgameid: 1433395,
		player1: "Gheorghiu",
		player2: "Kavalek",
		year: 1969,
		opening: "(E83) King's Indian, Samisch",
		nbMoves: 25,
		score: "0-1",
		finalPosition: "/positions/1433395.png"
	},
	{
		title: "Polugaevsky vs Ftacnik no name",
		chessgameid: 1045547,
		player1: "Polugaevsky",
		player2: "Ftacnik",
		year: 1982,
		opening: "(A30) English, Symmetrical",
		nbMoves: 29,
		score: "0-1",
		finalPosition: "/positions/1045547.png"
	},
	{
		title: "Shirov vs Polgar no name",
		chessgameid: 1111195,
		player1: "Shirov",
		player2: "Polgar",
		year: 1994,
		opening: "(B45) Sicilian, Taimanov",
		nbMoves: 29,
		score: "0-1",
		finalPosition: "/positions/1111195.png"
	},
	{
		title: "Maroczy vs Chigorin no name",
		chessgameid: 1036581,
		player1: "Maroczy",
		player2: "Chigorin",
		year: 1903,
		opening: "(C37) King's Gambit Accepted",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1036581.png"
	},
	{
		title: "Kamsky vs Kramnik no name",
		chessgameid: 1066737,
		player1: "Kamsky",
		player2: "Kramnik",
		year: 1994,
		opening: "(D44) Queen's Gambit Declined Semi-Slav",
		nbMoves: 41,
		score: "1-0",
		finalPosition: "/positions/1066737.png"
	},
	{
		title: "Sultan Khan vs Capablanca no name",
		chessgameid: 1135510,
		player1: "Sultan Khan",
		player2: "Capablanca",
		year: 1930,
		opening: "(E12) Queen's Indian",
		nbMoves: 65,
		score: "1-0",
		finalPosition: "/positions/1135510.png"
	},
	{
		title: "Kharlov vs Topalov no name",
		chessgameid: 1292559,
		player1: "Kharlov",
		player2: "Topalov",
		year: 2004,
		opening: "(C24) Bishop's Opening",
		nbMoves: 53,
		score: "0-1",
		finalPosition: "/positions/1292559.png"
	},
	{
		title: "Landa vs E Shaposhnikov no name",
		chessgameid: 1340107,
		player1: "Landa",
		player2: "E Shaposhnikov",
		year: 2005,
		opening: "(B18) Caro-Kann, Classical",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1340107.png"
	},
	{
		title: "Marshall vs Janowski no name",
		chessgameid: 1094454,
		player1: "Marshall",
		player2: "Janowski",
		year: 1899,
		opening: "(B45) Sicilian, Taimanov",
		nbMoves: 47,
		score: "0-1",
		finalPosition: "/positions/1094454.png"
	},
	{
		title: "Sutovsky vs Smirin no name",
		chessgameid: 1278763,
		player1: "Sutovsky",
		player2: "Smirin",
		year: 2002,
		opening: "(B25) Sicilian, Closed",
		nbMoves: 24,
		score: "1-0",
		finalPosition: "/positions/1278763.png"
	},
	{
		title: "Kramnik vs Anand no name",
		chessgameid: 1173387,
		player1: "Kramnik",
		player2: "Anand",
		year: 2001,
		opening: "(D27) Queen's Gambit Accepted, Classical",
		nbMoves: 39,
		score: "1-0",
		finalPosition: "/positions/1173387.png"
	},
	{
		title: "Gelfand vs B Kantsler no name",
		chessgameid: 1361795,
		player1: "Gelfand",
		player2: "B Kantsler",
		year: 2001,
		opening: "(E98) King's Indian, Orthodox, Taimanov, 9.Ne1",
		nbMoves: 34,
		score: "0-1",
		finalPosition: "/positions/1361795.png"
	},
	{
		title: "I Sokolov vs Dreev no name",
		chessgameid: 1218523,
		player1: "I Sokolov",
		player2: "Dreev",
		year: 2001,
		opening: "(D44) Queen's Gambit Declined Semi-Slav",
		nbMoves: 31,
		score: "0-1",
		finalPosition: "/positions/1218523.png"
	},
	{
		title: "Svidler vs Adams no name",
		chessgameid: 1321967,
		player1: "Svidler",
		player2: "Adams",
		year: 2000,
		opening: "(C78) Ruy Lopez",
		nbMoves: 34,
		score: "1-0",
		finalPosition: "/positions/1321967.png"
	},
	{
		title: "Topalov vs Ivanchuk no name",
		chessgameid: 1406152,
		player1: "Topalov",
		player2: "Ivanchuk",
		year: 1999,
		opening: "(A04) Reti Opening",
		nbMoves: 25,
		score: "0-1",
		finalPosition: "/positions/1406152.png"
	},
	{
		title: "Nunn vs I Nataf no name",
		chessgameid: 1333500,
		player1: "Nunn",
		player2: "I Nataf",
		year: 1999,
		opening: "(B32) Sicilian",
		nbMoves: 28,
		score: "0-1",
		finalPosition: "/positions/1333500.png"
	},
	{
		title: "A Veingold vs Fridman no name",
		chessgameid: 1361793,
		player1: "A Veingold",
		player2: "Fridman",
		year: 1998,
		opening: "(D44) Queen's Gambit Declined Semi-Slav",
		nbMoves: 36,
		score: "1-0",
		finalPosition: "/positions/1361793.png"
	},
	{
		title: "Gelfand vs Shirov no name",
		chessgameid: 1268704,
		player1: "Gelfand",
		player2: "Shirov",
		year: 1998,
		opening: "(D85) Grunfeld",
		nbMoves: 39,
		score: "1-0",
		finalPosition: "/positions/1268704.png"
	},
	{
		title: "Karjakin vs Malinin no name",
		chessgameid: 1253303,
		player1: "Karjakin",
		player2: "Malinin",
		year: 2002,
		opening: "(C45) Scotch Game",
		nbMoves: 20,
		score: "1-0",
		finalPosition: "/positions/1253303.png"
	},
	{
		title: "Anand vs Radjabov no name",
		chessgameid: 1266078,
		player1: "Anand",
		player2: "Radjabov",
		year: 2003,
		opening: "(B32) Sicilian",
		nbMoves: 39,
		score: "0-1",
		finalPosition: "/positions/1266078.png"
	},
	{
		title: "Nakamura vs J Fluvia Poyatos no name",
		chessgameid: 1477096,
		player1: "Nakamura",
		player2: "J Fluvia Poyatos",
		year: 2007,
		opening: "(D80) Grunfeld",
		nbMoves: 43,
		score: "1-0",
		finalPosition: "/positions/1477096.png"
	}
]


export default chessGames;